const uniaxialpower = [
  {
    x: 0.0400073,
    torque: 0.00000192905,
    y: 0.077674
  },
  {
    x: 0.0800073,
    torque: 0.00000192905,
    y: 0.0795017
  },
  {
    x: 1.00001,
    torque: 0.151709,
    y: 0.108744
  },
  {
    x: 1.62001,
    torque: 0.429838,
    y: 0.129762
  },
  {
    x: 2.24001,
    torque: 0.707967,
    y: 0.149866
  },
  {
    x: 2.86001,
    torque: 0.935527,
    y: 0.172711
  },
  {
    x: 3.48001,
    torque: 1.23894,
    y: 0.190987
  },
  {
    x: 4.10001,
    torque: 1.51707,
    y: 0.212919
  },
  {
    x: 4.72001,
    torque: 1.76991,
    y: 0.233023
  },
  {
    x: 5.32001,
    torque: 2.04804,
    y: 0.253127
  },
  {
    x: 5.92001,
    torque: 2.2756,
    y: 0.266834
  },
  {
    x: 6.52001,
    torque: 2.55373,
    y: 0.284196
  },
  {
    x: 7.14001,
    torque: 2.75601,
    y: 0.300645
  },
  {
    x: 7.76001,
    torque: 2.95828,
    y: 0.320749
  },
  {
    x: 8.38001,
    torque: 3.18584,
    y: 0.339939
  },
  {
    x: 9.00001,
    torque: 3.4134,
    y: 0.355474
  },
  {
    x: 9.62001,
    torque: 3.69153,
    y: 0.371009
  },
  {
    x: 10.22,
    torque: 3.96966,
    y: 0.388372
  },
  {
    x: 10.84,
    torque: 4.24779,
    y: 0.402079
  },
  {
    x: 11.46,
    torque: 4.52592,
    y: 0.418527
  },
  {
    x: 12.06,
    torque: 4.77876,
    y: 0.428579
  },
  {
    x: 12.68,
    torque: 5.03161,
    y: 0.446856
  },
  {
    x: 13.3,
    torque: 5.28445,
    y: 0.459649
  },
  {
    x: 13.92,
    torque: 5.5373,
    y: 0.476098
  },
  {
    x: 14.52,
    torque: 5.81543,
    y: 0.490719
  },
  {
    x: 15.14,
    torque: 6.06827,
    y: 0.504426
  },
  {
    x: 15.74,
    torque: 6.29583,
    y: 0.51722
  },
  {
    x: 16.34,
    torque: 6.54867,
    y: 0.533668
  },
  {
    x: 16.94,
    torque: 6.8268,
    y: 0.54372
  },
  {
    x: 17.56,
    torque: 7.05436,
    y: 0.551945
  },
  {
    x: 18.18,
    torque: 7.30721,
    y: 0.565652
  },
  {
    x: 18.8,
    torque: 7.61062,
    y: 0.577531
  },
  {
    x: 19.4,
    torque: 7.8129,
    y: 0.590325
  },
  {
    x: 20,
    torque: 8.14159,
    y: 0.603118
  },
  {
    x: 20.62,
    torque: 8.36915,
    y: 0.614084
  },
  {
    x: 21.24,
    torque: 8.64728,
    y: 0.626878
  },
  {
    x: 21.86,
    torque: 8.92541,
    y: 0.638757
  },
  {
    x: 22.48,
    torque: 9.25411,
    y: 0.654292
  },
  {
    x: 23.1,
    torque: 9.53224,
    y: 0.666172
  },
  {
    x: 23.72,
    torque: 9.83565,
    y: 0.676224
  },
  {
    x: 24.34,
    torque: 10.1138,
    y: 0.689017
  },
  {
    x: 24.96,
    torque: 10.4172,
    y: 0.699983
  },
  {
    x: 25.58,
    torque: 10.67,
    y: 0.710949
  },
  {
    x: 26.18,
    torque: 10.9482,
    y: 0.720087
  },
  {
    x: 26.78,
    torque: 11.201,
    y: 0.730139
  },
  {
    x: 27.4,
    torque: 11.4791,
    y: 0.742018
  },
  {
    x: 28,
    torque: 11.732,
    y: 0.752984
  },
  {
    x: 28.62,
    torque: 11.9848,
    y: 0.76395
  },
  {
    x: 29.22,
    torque: 12.263,
    y: 0.77583
  },
  {
    x: 29.82,
    torque: 12.5158,
    y: 0.784968
  },
  {
    x: 30.42,
    torque: 12.7939,
    y: 0.79502
  },
  {
    x: 31.02,
    torque: 13.0468,
    y: 0.80233
  },
  {
    x: 31.64,
    torque: 13.3502,
    y: 0.816037
  },
  {
    x: 32.26,
    torque: 13.603,
    y: 0.824262
  },
  {
    x: 32.88,
    torque: 13.8812,
    y: 0.8334
  },
  {
    x: 33.5,
    torque: 14.1087,
    y: 0.842538
  },
  {
    x: 34.12,
    torque: 14.4121,
    y: 0.85259
  },
  {
    x: 34.74,
    torque: 14.7156,
    y: 0.86447
  },
  {
    x: 35.36,
    torque: 14.9937,
    y: 0.874522
  },
  {
    x: 35.96,
    torque: 15.2718,
    y: 0.881832
  },
  {
    x: 36.56,
    torque: 15.4994,
    y: 0.892798
  },
  {
    x: 37.16,
    torque: 15.7775,
    y: 0.900109
  },
  {
    x: 37.78,
    torque: 16.0051,
    y: 0.911074
  },
  {
    x: 38.4,
    torque: 16.3338,
    y: 0.918385
  },
  {
    x: 39,
    torque: 16.6119,
    y: 0.928437
  },
  {
    x: 39.62,
    torque: 16.9406,
    y: 0.937575
  },
  {
    x: 40.22,
    torque: 17.1934,
    y: 0.945799
  },
  {
    x: 40.84,
    torque: 17.4463,
    y: 0.954024
  },
  {
    x: 41.46,
    torque: 17.7244,
    y: 0.964076
  },
  {
    x: 42.06,
    torque: 18.0025,
    y: 0.970472
  },
  {
    x: 42.68,
    torque: 18.2554,
    y: 0.979611
  },
  {
    x: 43.3,
    torque: 18.5335,
    y: 0.989663
  },
  {
    x: 43.92,
    torque: 18.7863,
    y: 1.00063
  },
  {
    x: 44.54,
    torque: 19.0645,
    y: 1.0052
  },
  {
    x: 45.14,
    torque: 19.3173,
    y: 1.01525
  },
  {
    x: 45.74,
    torque: 19.5702,
    y: 1.02439
  },
  {
    x: 46.34,
    torque: 19.8989,
    y: 1.03353
  },
  {
    x: 46.96,
    torque: 20.2023,
    y: 1.04084
  },
  {
    x: 47.58,
    torque: 20.4298,
    y: 1.04906
  },
  {
    x: 48.2,
    torque: 20.7333,
    y: 1.05454
  },
  {
    x: 48.82,
    torque: 21.0114,
    y: 1.06368
  },
  {
    x: 49.42,
    torque: 21.2642,
    y: 1.07373
  },
  {
    x: 50.02,
    torque: 21.5424,
    y: 1.07922
  },
  {
    x: 50.64,
    torque: 21.7952,
    y: 1.08927
  },
  {
    x: 51.26,
    torque: 22.1745,
    y: 1.09475
  },
  {
    x: 51.88,
    torque: 22.4273,
    y: 1.10572
  },
  {
    x: 52.48,
    torque: 22.6549,
    y: 1.11394
  },
  {
    x: 53.1,
    torque: 22.9836,
    y: 1.12125
  },
  {
    x: 53.7,
    torque: 23.2617,
    y: 1.12673
  },
  {
    x: 54.32,
    torque: 23.5904,
    y: 1.13587
  },
  {
    x: 54.94,
    torque: 23.8432,
    y: 1.1441
  },
  {
    x: 55.56,
    torque: 24.1719,
    y: 1.15141
  },
  {
    x: 56.16,
    torque: 24.3995,
    y: 1.15963
  },
  {
    x: 56.76,
    torque: 24.5765,
    y: 1.16603
  },
  {
    x: 57.38,
    torque: 24.8293,
    y: 1.17517
  },
  {
    x: 57.98,
    torque: 25.0822,
    y: 1.18339
  },
  {
    x: 58.6,
    torque: 25.4109,
    y: 1.19162
  },
  {
    x: 59.2,
    torque: 25.6637,
    y: 1.19893
  },
  {
    x: 59.8,
    torque: 25.9166,
    y: 1.20441
  },
  {
    x: 60.4,
    torque: 26.22,
    y: 1.21081
  },
  {
    x: 61.02,
    torque: 26.5234,
    y: 1.21629
  },
  {
    x: 61.64,
    torque: 26.7762,
    y: 1.22725
  },
  {
    x: 62.26,
    torque: 27.0796,
    y: 1.23548
  },
  {
    x: 62.86,
    torque: 27.3325,
    y: 1.24096
  },
  {
    x: 63.48,
    torque: 27.6359,
    y: 1.2501
  },
  {
    x: 64.1,
    torque: 27.8888,
    y: 1.25741
  },
  {
    x: 64.72,
    torque: 28.1922,
    y: 1.26472
  },
  {
    x: 65.32,
    torque: 28.4956,
    y: 1.2702
  },
  {
    x: 65.94,
    torque: 28.7737,
    y: 1.27843
  },
  {
    x: 66.54,
    torque: 29.0771,
    y: 1.28026
  },
  {
    x: 67.16,
    torque: 29.3047,
    y: 1.29031
  },
  {
    x: 67.78,
    torque: 29.6587,
    y: 1.2967
  },
  {
    x: 68.4,
    torque: 29.9115,
    y: 1.30676
  },
  {
    x: 69,
    torque: 30.1896,
    y: 1.31224
  },
  {
    x: 69.62,
    torque: 30.4425,
    y: 1.32321
  },
  {
    x: 70.22,
    torque: 30.7206,
    y: 1.32686
  },
  {
    x: 70.84,
    torque: 30.9482,
    y: 1.33509
  },
  {
    x: 71.46,
    torque: 31.2516,
    y: 1.34057
  },
  {
    x: 72.06,
    torque: 31.4791,
    y: 1.34879
  },
  {
    x: 72.68,
    torque: 31.8331,
    y: 1.35428
  },
  {
    x: 73.3,
    torque: 32.1113,
    y: 1.36067
  },
  {
    x: 73.92,
    torque: 32.3641,
    y: 1.3689
  },
  {
    x: 74.52,
    torque: 32.6169,
    y: 1.37712
  },
  {
    x: 75.12,
    torque: 32.8951,
    y: 1.38352
  },
  {
    x: 75.74,
    torque: 33.1479,
    y: 1.39448
  },
  {
    x: 76.34,
    torque: 33.4008,
    y: 1.39814
  },
  {
    x: 76.94,
    torque: 33.6283,
    y: 1.40362
  },
  {
    x: 77.56,
    torque: 33.9823,
    y: 1.4091
  },
  {
    x: 78.16,
    torque: 34.2099,
    y: 1.4155
  },
  {
    x: 78.78,
    torque: 34.4627,
    y: 1.42098
  },
  {
    x: 79.38,
    torque: 34.7408,
    y: 1.42647
  },
  {
    x: 80,
    torque: 34.9937,
    y: 1.43469
  },
  {
    x: 80.62,
    torque: 35.2971,
    y: 1.44383
  },
  {
    x: 81.24,
    torque: 35.5752,
    y: 1.45205
  },
  {
    x: 81.84,
    torque: 35.8281,
    y: 1.45754
  },
  {
    x: 82.46,
    torque: 36.1062,
    y: 1.46667
  },
  {
    x: 83.06,
    torque: 36.3843,
    y: 1.47399
  },
  {
    x: 83.68,
    torque: 36.6625,
    y: 1.47764
  },
  {
    x: 84.3,
    torque: 36.9153,
    y: 1.48312
  },
  {
    x: 84.9,
    torque: 37.1934,
    y: 1.48952
  },
  {
    x: 85.5,
    torque: 37.4463,
    y: 1.49683
  },
  {
    x: 86.1,
    torque: 37.7244,
    y: 1.50505
  },
  {
    x: 86.7,
    torque: 37.952,
    y: 1.51328
  },
  {
    x: 87.32,
    torque: 38.2807,
    y: 1.51876
  },
  {
    x: 87.92,
    torque: 38.5335,
    y: 1.5279
  },
  {
    x: 88.54,
    torque: 38.8116,
    y: 1.53338
  },
  {
    x: 89.14,
    torque: 39.0392,
    y: 1.53795
  },
  {
    x: 89.74,
    torque: 39.3173,
    y: 1.54526
  },
  {
    x: 90.36,
    torque: 39.6207,
    y: 1.54983
  },
  {
    x: 90.98,
    torque: 39.8736,
    y: 1.55531
  },
  {
    x: 91.6,
    torque: 40.1011,
    y: 1.56628
  },
  {
    x: 92.22,
    torque: 40.354,
    y: 1.57268
  },
  {
    x: 92.82,
    torque: 40.6321,
    y: 1.57816
  },
  {
    x: 93.44,
    torque: 40.885,
    y: 1.58547
  },
  {
    x: 94.04,
    torque: 41.1631,
    y: 1.59644
  },
  {
    x: 94.66,
    torque: 41.4159,
    y: 1.60101
  },
  {
    x: 95.28,
    torque: 41.7446,
    y: 1.60649
  },
  {
    x: 95.88,
    torque: 42.0228,
    y: 1.61289
  },
  {
    x: 96.5,
    torque: 42.2503,
    y: 1.61563
  },
  {
    x: 97.12,
    torque: 42.5537,
    y: 1.62385
  },
  {
    x: 97.74,
    torque: 42.8319,
    y: 1.63208
  },
  {
    x: 98.36,
    torque: 43.0847,
    y: 1.63847
  },
  {
    x: 98.96,
    torque: 43.3123,
    y: 1.64487
  },
  {
    x: 99.56,
    torque: 43.5904,
    y: 1.65127
  },
  {
    x: 100.18,
    torque: 43.8938,
    y: 1.65949
  },
  {
    x: 100.8,
    torque: 44.1467,
    y: 1.67137
  },
  {
    x: 101.42,
    torque: 44.4248,
    y: 1.6732
  },
  {
    x: 102.04,
    torque: 44.7029,
    y: 1.67777
  },
  {
    x: 102.66,
    torque: 45.0063,
    y: 1.68142
  },
  {
    x: 103.26,
    torque: 45.2844,
    y: 1.68873
  },
  {
    x: 103.88,
    torque: 45.512,
    y: 1.69604
  },
  {
    x: 104.48,
    torque: 45.8154,
    y: 1.70427
  },
  {
    x: 105.1,
    torque: 46.043,
    y: 1.71158
  },
  {
    x: 105.7,
    torque: 46.2453,
    y: 1.7198
  },
  {
    x: 106.3,
    torque: 46.4223,
    y: 1.72711
  },
  {
    x: 106.92,
    torque: 46.7004,
    y: 1.73351
  },
  {
    x: 107.54,
    torque: 47.0038,
    y: 1.73991
  },
  {
    x: 108.16,
    torque: 47.2061,
    y: 1.74447
  },
  {
    x: 108.76,
    torque: 47.4842,
    y: 1.75087
  },
  {
    x: 109.36,
    torque: 47.7623,
    y: 1.75818
  },
  {
    x: 109.98,
    torque: 48.0152,
    y: 1.76366
  },
  {
    x: 110.6,
    torque: 48.3186,
    y: 1.7728
  },
  {
    x: 111.22,
    torque: 48.5714,
    y: 1.77829
  },
  {
    x: 111.82,
    torque: 48.8243,
    y: 1.78742
  },
  {
    x: 112.44,
    torque: 49.0771,
    y: 1.79565
  },
  {
    x: 113.06,
    torque: 49.33,
    y: 1.79839
  },
  {
    x: 113.68,
    torque: 49.5828,
    y: 1.80479
  },
  {
    x: 114.28,
    torque: 49.8357,
    y: 1.81027
  },
  {
    x: 114.88,
    torque: 50.1138,
    y: 1.81667
  },
  {
    x: 115.5,
    torque: 50.3666,
    y: 1.82489
  },
  {
    x: 116.12,
    torque: 50.6195,
    y: 1.83311
  },
  {
    x: 116.74,
    torque: 50.9229,
    y: 1.8386
  },
  {
    x: 117.36,
    torque: 51.1504,
    y: 1.84591
  },
  {
    x: 117.98,
    torque: 51.4286,
    y: 1.85413
  },
  {
    x: 118.6,
    torque: 51.6561,
    y: 1.86144
  },
  {
    x: 119.22,
    torque: 51.9343,
    y: 1.86784
  },
  {
    x: 119.82,
    torque: 52.1618,
    y: 1.87241
  },
  {
    x: 120.42,
    torque: 52.3894,
    y: 1.87881
  },
  {
    x: 121.02,
    torque: 52.6422,
    y: 1.88429
  },
  {
    x: 121.64,
    torque: 52.9204,
    y: 1.89434
  },
  {
    x: 122.26,
    torque: 53.1732,
    y: 1.90165
  },
  {
    x: 122.88,
    torque: 53.426,
    y: 1.90896
  },
  {
    x: 123.48,
    torque: 53.6789,
    y: 1.91444
  },
  {
    x: 124.1,
    torque: 53.957,
    y: 1.92267
  },
  {
    x: 124.7,
    torque: 54.2099,
    y: 1.92907
  },
  {
    x: 125.3,
    torque: 54.3869,
    y: 1.93455
  },
  {
    x: 125.92,
    torque: 54.665,
    y: 1.94186
  },
  {
    x: 126.52,
    torque: 54.8925,
    y: 1.94643
  },
  {
    x: 127.14,
    torque: 55.2212,
    y: 1.95191
  },
  {
    x: 127.76,
    torque: 55.4235,
    y: 1.96288
  },
  {
    x: 128.38,
    torque: 55.6511,
    y: 1.96745
  },
  {
    x: 129,
    torque: 55.9545,
    y: 1.97567
  },
  {
    x: 129.62,
    torque: 56.1821,
    y: 1.98572
  },
  {
    x: 130.22,
    torque: 56.4349,
    y: 1.99029
  },
  {
    x: 130.82,
    torque: 56.6625,
    y: 1.99852
  },
  {
    x: 131.44,
    torque: 56.9153,
    y: 2.00217
  },
  {
    x: 132.06,
    torque: 57.1681,
    y: 2.00948
  },
  {
    x: 132.68,
    torque: 57.421,
    y: 2.01771
  },
  {
    x: 133.28,
    torque: 57.6738,
    y: 2.02502
  },
  {
    x: 133.9,
    torque: 57.9267,
    y: 2.03324
  },
  {
    x: 134.5,
    torque: 58.2048,
    y: 2.03872
  },
  {
    x: 135.12,
    torque: 58.4071,
    y: 2.04512
  },
  {
    x: 135.72,
    torque: 58.6599,
    y: 2.05152
  },
  {
    x: 136.32,
    torque: 58.8875,
    y: 2.06157
  },
  {
    x: 136.94,
    torque: 59.1656,
    y: 2.06797
  },
  {
    x: 137.56,
    torque: 59.4185,
    y: 2.07528
  },
  {
    x: 138.18,
    torque: 59.6713,
    y: 2.07985
  },
  {
    x: 138.8,
    torque: 59.8989,
    y: 2.08807
  },
  {
    x: 139.42,
    torque: 60.2023,
    y: 2.09538
  },
  {
    x: 140.02,
    torque: 60.4298,
    y: 2.10086
  },
  {
    x: 140.62,
    torque: 60.6827,
    y: 2.10726
  },
  {
    x: 141.24,
    torque: 60.9102,
    y: 2.11731
  },
  {
    x: 141.86,
    torque: 61.1884,
    y: 2.12188
  },
  {
    x: 142.48,
    torque: 61.4159,
    y: 2.12919
  },
  {
    x: 143.08,
    torque: 61.6182,
    y: 2.13559
  },
  {
    x: 143.7,
    torque: 61.8458,
    y: 2.13924
  },
  {
    x: 144.32,
    torque: 62.1239,
    y: 2.14747
  },
  {
    x: 144.94,
    torque: 62.3515,
    y: 2.15386
  },
  {
    x: 145.56,
    torque: 62.6043,
    y: 2.16392
  },
  {
    x: 146.18,
    torque: 62.8571,
    y: 2.17031
  },
  {
    x: 146.78,
    torque: 63.11,
    y: 2.17671
  },
  {
    x: 147.38,
    torque: 63.3628,
    y: 2.18219
  },
  {
    x: 148,
    torque: 63.6157,
    y: 2.19133
  },
  {
    x: 148.62,
    torque: 63.818,
    y: 2.19956
  },
  {
    x: 149.24,
    torque: 64.0961,
    y: 2.20778
  },
  {
    x: 149.86,
    torque: 64.3489,
    y: 2.21509
  },
  {
    x: 150.46,
    torque: 64.6018,
    y: 2.21875
  },
  {
    x: 151.06,
    torque: 64.8293,
    y: 2.22606
  },
  {
    x: 151.68,
    torque: 65.0569,
    y: 2.23428
  },
  {
    x: 152.3,
    torque: 65.3097,
    y: 2.24159
  },
  {
    x: 152.92,
    torque: 65.5879,
    y: 2.24616
  },
  {
    x: 153.52,
    torque: 65.8154,
    y: 2.25438
  },
  {
    x: 154.14,
    torque: 66.0683,
    y: 2.26352
  },
  {
    x: 154.76,
    torque: 66.3464,
    y: 2.27175
  },
  {
    x: 155.38,
    torque: 66.4981,
    y: 2.27906
  },
  {
    x: 156,
    torque: 66.7004,
    y: 2.28637
  },
  {
    x: 156.62,
    torque: 66.8774,
    y: 2.29368
  },
  {
    x: 157.24,
    torque: 67.1808,
    y: 2.29825
  },
  {
    x: 157.86,
    torque: 67.4336,
    y: 2.30739
  },
  {
    x: 158.46,
    torque: 67.6865,
    y: 2.31287
  },
  {
    x: 159.06,
    torque: 67.914,
    y: 2.32201
  },
  {
    x: 159.68,
    torque: 68.1669,
    y: 2.3284
  },
  {
    x: 160.3,
    torque: 68.3944,
    y: 2.33297
  },
  {
    x: 160.92,
    torque: 68.622,
    y: 2.34302
  },
  {
    x: 161.54,
    torque: 68.8748,
    y: 2.35308
  },
  {
    x: 162.16,
    torque: 69.153,
    y: 2.35856
  },
  {
    x: 162.78,
    torque: 69.3805,
    y: 2.36404
  },
  {
    x: 163.38,
    torque: 69.6081,
    y: 2.37318
  },
  {
    x: 163.98,
    torque: 69.8104,
    y: 2.37775
  },
  {
    x: 164.6,
    torque: 70.0379,
    y: 2.38597
  },
  {
    x: 165.2,
    torque: 70.3161,
    y: 2.3942
  },
  {
    x: 165.82,
    torque: 70.493,
    y: 2.39328
  },
  {
    x: 166.44,
    torque: 70.7965,
    y: 2.40516
  },
  {
    x: 167.06,
    torque: 71.024,
    y: 2.41613
  },
  {
    x: 167.68,
    torque: 71.3022,
    y: 2.42253
  },
  {
    x: 168.28,
    torque: 71.4539,
    y: 2.4271
  },
  {
    x: 168.88,
    torque: 71.732,
    y: 2.43532
  },
  {
    x: 169.5,
    torque: 71.9343,
    y: 2.4408
  },
  {
    x: 170.1,
    torque: 72.1618,
    y: 2.44811
  },
  {
    x: 170.72,
    torque: 72.3641,
    y: 2.45542
  },
  {
    x: 171.34,
    torque: 72.5411,
    y: 2.46365
  },
  {
    x: 171.96,
    torque: 72.7939,
    y: 2.47004
  },
  {
    x: 172.58,
    torque: 73.0215,
    y: 2.4801
  },
  {
    x: 173.18,
    torque: 73.2743,
    y: 2.48467
  },
  {
    x: 173.78,
    torque: 73.4766,
    y: 2.49198
  },
  {
    x: 174.4,
    torque: 73.7295,
    y: 2.49929
  },
  {
    x: 175.02,
    torque: 73.957,
    y: 2.50842
  },
  {
    x: 175.64,
    torque: 74.2351,
    y: 2.51482
  },
  {
    x: 176.24,
    torque: 74.4374,
    y: 2.52579
  },
  {
    x: 176.86,
    torque: 74.6903,
    y: 2.53127
  },
  {
    x: 177.48,
    torque: 74.9684,
    y: 2.53584
  },
  {
    x: 178.1,
    torque: 75.196,
    y: 2.54589
  },
  {
    x: 178.72,
    torque: 75.4488,
    y: 2.5532
  },
  {
    x: 179.32,
    torque: 75.6764,
    y: 2.5596
  },
  {
    x: 179.92,
    torque: 75.9039,
    y: 2.566
  },
  {
    x: 180.52,
    torque: 76.1315,
    y: 2.57148
  },
  {
    x: 181.14,
    torque: 76.359,
    y: 2.58153
  },
  {
    x: 181.76,
    torque: 76.5866,
    y: 2.58884
  },
  {
    x: 182.38,
    torque: 76.8394,
    y: 2.59615
  },
  {
    x: 183,
    torque: 77.0164,
    y: 2.60255
  },
  {
    x: 183.62,
    torque: 77.244,
    y: 2.61169
  },
  {
    x: 184.22,
    torque: 77.4968,
    y: 2.61808
  },
  {
    x: 184.82,
    torque: 77.7244,
    y: 2.62539
  },
  {
    x: 185.44,
    torque: 77.9014,
    y: 2.63453
  },
  {
    x: 186.06,
    torque: 78.129,
    y: 2.64184
  },
  {
    x: 186.68,
    torque: 78.3312,
    y: 2.64641
  },
  {
    x: 187.28,
    torque: 78.5841,
    y: 2.65372
  },
  {
    x: 187.9,
    torque: 78.8116,
    y: 2.6656
  },
  {
    x: 188.52,
    torque: 79.0645,
    y: 2.66834
  },
  {
    x: 189.14,
    torque: 79.2415,
    y: 2.67931
  },
  {
    x: 189.74,
    torque: 79.4943,
    y: 2.68753
  },
  {
    x: 190.34,
    torque: 79.6966,
    y: 2.69302
  },
  {
    x: 190.96,
    torque: 79.9494,
    y: 2.70033
  },
  {
    x: 191.58,
    torque: 80.1517,
    y: 2.70764
  },
  {
    x: 192.2,
    torque: 80.354,
    y: 2.71312
  },
  {
    x: 192.82,
    torque: 80.5815,
    y: 2.71952
  },
  {
    x: 193.44,
    torque: 80.7838,
    y: 2.72591
  },
  {
    x: 194.06,
    torque: 80.9861,
    y: 2.73505
  },
  {
    x: 194.66,
    torque: 81.1884,
    y: 2.74328
  },
  {
    x: 195.26,
    torque: 81.4159,
    y: 2.75241
  },
  {
    x: 195.88,
    torque: 81.6688,
    y: 2.75972
  },
  {
    x: 196.5,
    torque: 81.8963,
    y: 2.76886
  },
  {
    x: 197.12,
    torque: 82.0986,
    y: 2.77435
  },
  {
    x: 197.74,
    torque: 82.3262,
    y: 2.78166
  },
  {
    x: 198.36,
    torque: 82.5284,
    y: 2.78988
  },
  {
    x: 198.98,
    torque: 82.756,
    y: 2.79628
  },
  {
    x: 199.6,
    torque: 83.0089,
    y: 2.80633
  },
  {
    x: 200.22,
    torque: 83.2364,
    y: 2.81181
  },
  {
    x: 200.82,
    torque: 83.4134,
    y: 2.82004
  },
  {
    x: 201.42,
    torque: 83.6157,
    y: 2.82643
  },
  {
    x: 202.02,
    torque: 83.818,
    y: 2.83831
  },
  {
    x: 202.64,
    torque: 84.0961,
    y: 2.84562
  },
  {
    x: 203.24,
    torque: 84.2731,
    y: 2.85293
  },
  {
    x: 203.86,
    torque: 84.5512,
    y: 2.8575
  },
  {
    x: 204.46,
    torque: 84.7282,
    y: 2.8639
  },
  {
    x: 205.06,
    torque: 84.9305,
    y: 2.87212
  },
  {
    x: 205.68,
    torque: 85.1833,
    y: 2.88126
  },
  {
    x: 206.28,
    torque: 85.3856,
    y: 2.88766
  },
  {
    x: 206.9,
    torque: 85.5879,
    y: 2.89406
  },
  {
    x: 207.5,
    torque: 85.7396,
    y: 2.90593
  },
  {
    x: 208.12,
    torque: 85.8913,
    y: 2.90593
  },
  {
    x: 208.74,
    torque: 86.0936,
    y: 2.91507
  },
  {
    x: 209.36,
    torque: 86.2705,
    y: 2.92238
  },
  {
    x: 209.98,
    torque: 86.4981,
    y: 2.93152
  },
  {
    x: 210.58,
    torque: 86.7257,
    y: 2.93883
  },
  {
    x: 211.18,
    torque: 86.9785,
    y: 2.94706
  },
  {
    x: 211.8,
    torque: 87.2061,
    y: 2.95528
  },
  {
    x: 212.42,
    torque: 87.4083,
    y: 2.95985
  },
  {
    x: 213.04,
    torque: 87.6359,
    y: 2.9699
  },
  {
    x: 213.66,
    torque: 87.8888,
    y: 2.97813
  },
  {
    x: 214.28,
    torque: 88.1163,
    y: 2.98635
  },
  {
    x: 214.88,
    torque: 88.2933,
    y: 2.99458
  },
  {
    x: 215.5,
    torque: 88.4956,
    y: 3.00006
  },
  {
    x: 216.12,
    torque: 88.6979,
    y: 3.00828
  },
  {
    x: 216.72,
    torque: 88.9507,
    y: 3.01833
  },
  {
    x: 217.34,
    torque: 89.153,
    y: 3.02564
  },
  {
    x: 217.94,
    torque: 89.3552,
    y: 3.03204
  },
  {
    x: 218.56,
    torque: 89.5828,
    y: 3.03935
  },
  {
    x: 219.18,
    torque: 89.7851,
    y: 3.04666
  },
  {
    x: 219.8,
    torque: 90.0379,
    y: 3.05854
  },
  {
    x: 220.42,
    torque: 90.2402,
    y: 3.06585
  },
  {
    x: 221.02,
    torque: 90.4678,
    y: 3.07134
  },
  {
    x: 221.64,
    torque: 90.6448,
    y: 3.08139
  },
  {
    x: 222.24,
    torque: 90.8217,
    y: 3.08778
  },
  {
    x: 222.86,
    torque: 91.0746,
    y: 3.09509
  },
  {
    x: 223.46,
    torque: 91.2516,
    y: 3.10058
  },
  {
    x: 224.08,
    torque: 91.4791,
    y: 3.10789
  },
  {
    x: 224.7,
    torque: 91.6814,
    y: 3.11703
  },
  {
    x: 225.3,
    torque: 91.8584,
    y: 3.12525
  },
  {
    x: 225.9,
    torque: 92.086,
    y: 3.13622
  },
  {
    x: 226.5,
    torque: 92.263,
    y: 3.1417
  },
  {
    x: 227.12,
    torque: 92.5158,
    y: 3.15084
  },
  {
    x: 227.72,
    torque: 92.7181,
    y: 3.15815
  },
  {
    x: 228.34,
    torque: 92.9456,
    y: 3.16729
  },
  {
    x: 228.94,
    torque: 93.0973,
    y: 3.16911
  },
  {
    x: 229.54,
    torque: 93.2996,
    y: 3.18008
  },
  {
    x: 230.16,
    torque: 93.4766,
    y: 3.18374
  },
  {
    x: 230.76,
    torque: 93.7295,
    y: 3.19287
  },
  {
    x: 231.36,
    torque: 93.9317,
    y: 3.20384
  },
  {
    x: 231.98,
    torque: 94.134,
    y: 3.21024
  },
  {
    x: 232.6,
    torque: 94.3616,
    y: 3.22212
  },
  {
    x: 233.22,
    torque: 94.5638,
    y: 3.22577
  },
  {
    x: 233.82,
    torque: 94.7661,
    y: 3.23217
  },
  {
    x: 234.44,
    torque: 94.9937,
    y: 3.23765
  },
  {
    x: 235.04,
    torque: 95.2465,
    y: 3.24679
  },
  {
    x: 235.66,
    torque: 95.4235,
    y: 3.2541
  },
  {
    x: 236.26,
    torque: 95.6258,
    y: 3.26506
  },
  {
    x: 236.88,
    torque: 95.8028,
    y: 3.27329
  },
  {
    x: 237.5,
    torque: 96.0556,
    y: 3.27877
  },
  {
    x: 238.12,
    torque: 96.2579,
    y: 3.28882
  },
  {
    x: 238.74,
    torque: 96.5108,
    y: 3.29431
  },
  {
    x: 239.36,
    torque: 96.6372,
    y: 3.30436
  },
  {
    x: 239.96,
    torque: 96.89,
    y: 3.31076
  },
  {
    x: 240.56,
    torque: 97.067,
    y: 3.31715
  },
  {
    x: 241.16,
    torque: 97.3199,
    y: 3.32538
  },
  {
    x: 241.78,
    torque: 97.4968,
    y: 3.33086
  },
  {
    x: 242.4,
    torque: 97.6991,
    y: 3.33908
  },
  {
    x: 243.02,
    torque: 97.9014,
    y: 3.34548
  },
  {
    x: 243.64,
    torque: 98.129,
    y: 3.35462
  },
  {
    x: 244.24,
    torque: 98.3059,
    y: 3.36284
  },
  {
    x: 244.86,
    torque: 98.5082,
    y: 3.37289
  },
  {
    x: 245.46,
    torque: 98.6852,
    y: 3.38203
  },
  {
    x: 246.08,
    torque: 98.9128,
    y: 3.38477
  },
  {
    x: 246.7,
    torque: 99.0645,
    y: 3.393
  },
  {
    x: 247.3,
    torque: 99.292,
    y: 3.40396
  },
  {
    x: 247.92,
    torque: 99.4943,
    y: 3.41219
  },
  {
    x: 248.52,
    torque: 99.6966,
    y: 3.4195
  },
  {
    x: 249.14,
    torque: 99.8483,
    y: 3.4259
  },
  {
    x: 249.74,
    torque: 100.076,
    y: 3.43503
  },
  {
    x: 250.34,
    torque: 100.278,
    y: 3.44326
  },
  {
    x: 250.94,
    torque: 100.48,
    y: 3.45331
  },
  {
    x: 251.56,
    torque: 100.683,
    y: 3.45788
  },
  {
    x: 252.16,
    torque: 100.86,
    y: 3.46519
  },
  {
    x: 252.76,
    torque: 101.113,
    y: 3.47433
  },
  {
    x: 253.38,
    torque: 101.29,
    y: 3.48164
  },
  {
    x: 253.98,
    torque: 101.492,
    y: 3.48895
  },
  {
    x: 254.6,
    torque: 101.669,
    y: 3.49992
  },
  {
    x: 255.22,
    torque: 101.922,
    y: 3.50723
  },
  {
    x: 255.84,
    torque: 102.124,
    y: 3.51362
  },
  {
    x: 256.46,
    torque: 102.301,
    y: 3.52459
  },
  {
    x: 257.06,
    torque: 102.528,
    y: 3.52916
  },
  {
    x: 257.68,
    torque: 102.781,
    y: 3.5383
  },
  {
    x: 258.3,
    torque: 102.958,
    y: 3.54286
  },
  {
    x: 258.92,
    torque: 103.186,
    y: 3.552
  },
  {
    x: 259.52,
    torque: 103.338,
    y: 3.56206
  },
  {
    x: 260.12,
    torque: 103.59,
    y: 3.56845
  },
  {
    x: 260.74,
    torque: 103.767,
    y: 3.57485
  },
  {
    x: 261.36,
    torque: 103.919,
    y: 3.58581
  },
  {
    x: 261.98,
    torque: 104.071,
    y: 3.59312
  },
  {
    x: 262.6,
    torque: 104.248,
    y: 3.60044
  },
  {
    x: 263.22,
    torque: 104.475,
    y: 3.60957
  },
  {
    x: 263.82,
    torque: 104.703,
    y: 3.61506
  },
  {
    x: 264.42,
    torque: 104.88,
    y: 3.62328
  },
  {
    x: 265.04,
    torque: 105.107,
    y: 3.62876
  },
  {
    x: 265.66,
    torque: 105.31,
    y: 3.64064
  },
  {
    x: 266.28,
    torque: 105.537,
    y: 3.64978
  },
  {
    x: 266.9,
    torque: 105.714,
    y: 3.65435
  },
  {
    x: 267.5,
    torque: 105.917,
    y: 3.66349
  },
  {
    x: 268.12,
    torque: 106.144,
    y: 3.67171
  },
  {
    x: 268.74,
    torque: 106.321,
    y: 3.68176
  },
  {
    x: 269.36,
    torque: 106.523,
    y: 3.68908
  },
  {
    x: 269.98,
    torque: 106.726,
    y: 3.69639
  },
  {
    x: 270.58,
    torque: 106.903,
    y: 3.70004
  },
  {
    x: 271.18,
    torque: 107.13,
    y: 3.71009
  },
  {
    x: 271.78,
    torque: 107.332,
    y: 3.71649
  },
  {
    x: 272.4,
    torque: 107.56,
    y: 3.72471
  },
  {
    x: 273.02,
    torque: 107.737,
    y: 3.73294
  },
  {
    x: 273.64,
    torque: 107.99,
    y: 3.74482
  },
  {
    x: 274.24,
    torque: 108.192,
    y: 3.75213
  },
  {
    x: 274.86,
    torque: 108.42,
    y: 3.76035
  },
  {
    x: 275.46,
    torque: 108.546,
    y: 3.76584
  },
  {
    x: 276.08,
    torque: 108.774,
    y: 3.77406
  },
  {
    x: 276.7,
    torque: 108.976,
    y: 3.78046
  },
  {
    x: 277.32,
    torque: 109.178,
    y: 3.78594
  },
  {
    x: 277.94,
    torque: 109.355,
    y: 3.79782
  },
  {
    x: 278.56,
    torque: 109.558,
    y: 3.80787
  },
  {
    x: 279.18,
    torque: 109.785,
    y: 3.81427
  },
  {
    x: 279.8,
    torque: 109.962,
    y: 3.82249
  },
  {
    x: 280.42,
    torque: 110.19,
    y: 3.83072
  },
  {
    x: 281.04,
    torque: 110.392,
    y: 3.83711
  },
  {
    x: 281.66,
    torque: 110.619,
    y: 3.84625
  },
  {
    x: 282.26,
    torque: 110.746,
    y: 3.85356
  },
  {
    x: 282.88,
    torque: 110.999,
    y: 3.85996
  },
  {
    x: 283.48,
    torque: 111.15,
    y: 3.86818
  },
  {
    x: 284.1,
    torque: 111.378,
    y: 3.87641
  },
  {
    x: 284.72,
    torque: 111.58,
    y: 3.88463
  },
  {
    x: 285.34,
    torque: 111.783,
    y: 3.89377
  },
  {
    x: 285.96,
    torque: 111.96,
    y: 3.90382
  },
  {
    x: 286.58,
    torque: 112.187,
    y: 3.91296
  },
  {
    x: 287.18,
    torque: 112.364,
    y: 3.91844
  },
  {
    x: 287.78,
    torque: 112.617,
    y: 3.92667
  },
  {
    x: 288.38,
    torque: 112.769,
    y: 3.93489
  },
  {
    x: 289,
    torque: 112.971,
    y: 3.94037
  },
  {
    x: 289.62,
    torque: 113.123,
    y: 3.94951
  },
  {
    x: 290.24,
    torque: 113.35,
    y: 3.95865
  },
  {
    x: 290.86,
    torque: 113.552,
    y: 3.96596
  },
  {
    x: 291.48,
    torque: 113.78,
    y: 3.9751
  },
  {
    x: 292.1,
    torque: 113.957,
    y: 3.98332
  },
  {
    x: 292.72,
    torque: 114.109,
    y: 3.99063
  },
  {
    x: 293.32,
    torque: 114.311,
    y: 3.99612
  },
  {
    x: 293.94,
    torque: 114.539,
    y: 4.00434
  },
  {
    x: 294.54,
    torque: 114.766,
    y: 4.00982
  },
  {
    x: 295.14,
    torque: 114.943,
    y: 4.01714
  },
  {
    x: 295.76,
    torque: 115.12,
    y: 4.02993
  },
  {
    x: 296.38,
    torque: 115.348,
    y: 4.03633
  },
  {
    x: 297,
    torque: 115.525,
    y: 4.04455
  },
  {
    x: 297.6,
    torque: 115.702,
    y: 4.05369
  },
  {
    x: 298.2,
    torque: 115.879,
    y: 4.06008
  },
  {
    x: 298.82,
    torque: 116.081,
    y: 4.0674
  },
  {
    x: 299.44,
    torque: 116.283,
    y: 4.07653
  },
  {
    x: 300.06,
    torque: 116.485,
    y: 4.0811
  },
  {
    x: 300.68,
    torque: 116.662,
    y: 4.09115
  },
  {
    x: 301.3,
    torque: 116.865,
    y: 4.10121
  },
  {
    x: 301.92,
    torque: 117.042,
    y: 4.1076
  },
  {
    x: 302.54,
    torque: 117.295,
    y: 4.11583
  },
  {
    x: 303.16,
    torque: 117.497,
    y: 4.12222
  },
  {
    x: 303.76,
    torque: 117.75,
    y: 4.13228
  },
  {
    x: 304.36,
    torque: 117.952,
    y: 4.13959
  },
  {
    x: 304.96,
    torque: 118.129,
    y: 4.14872
  },
  {
    x: 305.58,
    torque: 118.357,
    y: 4.15512
  },
  {
    x: 306.2,
    torque: 118.584,
    y: 4.16517
  },
  {
    x: 306.82,
    torque: 118.786,
    y: 4.17066
  },
  {
    x: 307.44,
    torque: 118.963,
    y: 4.17797
  },
  {
    x: 308.04,
    torque: 119.115,
    y: 4.18528
  },
  {
    x: 308.64,
    torque: 119.317,
    y: 4.1935
  },
  {
    x: 309.26,
    torque: 119.52,
    y: 4.20355
  },
  {
    x: 309.88,
    torque: 119.722,
    y: 4.21361
  },
  {
    x: 310.5,
    torque: 119.899,
    y: 4.22274
  },
  {
    x: 311.12,
    torque: 120.126,
    y: 4.22823
  },
  {
    x: 311.74,
    torque: 120.329,
    y: 4.23371
  },
  {
    x: 312.36,
    torque: 120.556,
    y: 4.24285
  },
  {
    x: 312.96,
    torque: 120.759,
    y: 4.24833
  },
  {
    x: 313.58,
    torque: 120.986,
    y: 4.25838
  },
  {
    x: 314.18,
    torque: 121.138,
    y: 4.26752
  },
  {
    x: 314.78,
    torque: 121.29,
    y: 4.27483
  },
  {
    x: 315.38,
    torque: 121.416,
    y: 4.28214
  },
  {
    x: 316,
    torque: 121.618,
    y: 4.29128
  },
  {
    x: 316.62,
    torque: 121.82,
    y: 4.29768
  },
  {
    x: 317.24,
    torque: 122.048,
    y: 4.30682
  },
  {
    x: 317.84,
    torque: 122.2,
    y: 4.31504
  },
  {
    x: 318.46,
    torque: 122.427,
    y: 4.32144
  },
  {
    x: 319.06,
    torque: 122.63,
    y: 4.32966
  },
  {
    x: 319.66,
    torque: 122.832,
    y: 4.33697
  },
  {
    x: 320.26,
    torque: 123.009,
    y: 4.34337
  },
  {
    x: 320.88,
    torque: 123.236,
    y: 4.34976
  },
  {
    x: 321.5,
    torque: 123.439,
    y: 4.3589
  },
  {
    x: 322.12,
    torque: 123.616,
    y: 4.36987
  },
  {
    x: 322.74,
    torque: 123.793,
    y: 4.37992
  },
  {
    x: 323.36,
    torque: 123.97,
    y: 4.3854
  },
  {
    x: 323.96,
    torque: 124.197,
    y: 4.3918
  },
  {
    x: 324.56,
    torque: 124.425,
    y: 4.40002
  },
  {
    x: 325.16,
    torque: 124.576,
    y: 4.41008
  },
  {
    x: 325.78,
    torque: 124.804,
    y: 4.41739
  },
  {
    x: 326.4,
    torque: 124.981,
    y: 4.42378
  },
  {
    x: 327.02,
    torque: 125.209,
    y: 4.43566
  },
  {
    x: 327.64,
    torque: 125.411,
    y: 4.44206
  },
  {
    x: 328.24,
    torque: 125.588,
    y: 4.44937
  },
  {
    x: 328.84,
    torque: 125.765,
    y: 4.45851
  },
  {
    x: 329.44,
    torque: 125.917,
    y: 4.46399
  },
  {
    x: 330.06,
    torque: 126.144,
    y: 4.47222
  },
  {
    x: 330.68,
    torque: 126.271,
    y: 4.4777
  },
  {
    x: 331.3,
    torque: 126.473,
    y: 4.48958
  },
  {
    x: 331.92,
    torque: 126.65,
    y: 4.4978
  },
  {
    x: 332.54,
    torque: 126.877,
    y: 4.50511
  },
  {
    x: 333.16,
    torque: 127.08,
    y: 4.51334
  },
  {
    x: 333.78,
    torque: 127.282,
    y: 4.52248
  },
  {
    x: 334.4,
    torque: 127.484,
    y: 4.52887
  },
  {
    x: 335,
    torque: 127.686,
    y: 4.53801
  },
  {
    x: 335.62,
    torque: 127.889,
    y: 4.54441
  },
  {
    x: 336.22,
    torque: 128.04,
    y: 4.5508
  },
  {
    x: 336.84,
    torque: 128.243,
    y: 4.55994
  },
  {
    x: 337.46,
    torque: 128.445,
    y: 4.56725
  },
  {
    x: 338.06,
    torque: 128.673,
    y: 4.57639
  },
  {
    x: 338.68,
    torque: 128.85,
    y: 4.5837
  },
  {
    x: 339.28,
    torque: 129.027,
    y: 4.59284
  },
  {
    x: 339.88,
    torque: 129.229,
    y: 4.59832
  },
  {
    x: 340.5,
    torque: 129.456,
    y: 4.6102
  },
  {
    x: 341.12,
    torque: 129.633,
    y: 4.61568
  },
  {
    x: 341.74,
    torque: 129.81,
    y: 4.62208
  },
  {
    x: 342.36,
    torque: 130.038,
    y: 4.62939
  },
  {
    x: 342.98,
    torque: 130.215,
    y: 4.63944
  },
  {
    x: 343.6,
    torque: 130.417,
    y: 4.64767
  },
  {
    x: 344.22,
    torque: 130.594,
    y: 4.65498
  },
  {
    x: 344.84,
    torque: 130.796,
    y: 4.66412
  },
  {
    x: 345.46,
    torque: 130.999,
    y: 4.67143
  },
  {
    x: 346.06,
    torque: 131.226,
    y: 4.676
  },
  {
    x: 346.66,
    torque: 131.353,
    y: 4.68788
  },
  {
    x: 347.26,
    torque: 131.555,
    y: 4.69519
  },
  {
    x: 347.88,
    torque: 131.732,
    y: 4.70158
  },
  {
    x: 348.5,
    torque: 131.96,
    y: 4.70798
  },
  {
    x: 349.12,
    torque: 132.137,
    y: 4.71803
  },
  {
    x: 349.74,
    torque: 132.339,
    y: 4.72717
  },
  {
    x: 350.34,
    torque: 132.516,
    y: 4.73357
  },
  {
    x: 350.94,
    torque: 132.693,
    y: 4.74088
  },
  {
    x: 351.54,
    torque: 132.87,
    y: 4.7491
  },
  {
    x: 352.16,
    torque: 133.072,
    y: 4.75915
  },
  {
    x: 352.78,
    torque: 133.274,
    y: 4.76646
  },
  {
    x: 353.4,
    torque: 133.477,
    y: 4.7756
  },
  {
    x: 354.02,
    torque: 133.654,
    y: 4.78109
  },
  {
    x: 354.64,
    torque: 133.831,
    y: 4.78931
  },
  {
    x: 355.26,
    torque: 134.033,
    y: 4.79571
  },
  {
    x: 355.88,
    torque: 134.21,
    y: 4.80667
  },
  {
    x: 356.48,
    torque: 134.412,
    y: 4.81398
  },
  {
    x: 357.08,
    torque: 134.614,
    y: 4.82312
  },
  {
    x: 357.68,
    torque: 134.817,
    y: 4.82678
  },
  {
    x: 358.3,
    torque: 135.019,
    y: 4.83774
  },
  {
    x: 358.92,
    torque: 135.196,
    y: 4.84688
  },
  {
    x: 359.54,
    torque: 135.424,
    y: 4.85419
  },
  {
    x: 360.16,
    torque: 135.626,
    y: 4.86242
  },
  {
    x: 360.76,
    torque: 135.803,
    y: 4.86973
  },
  {
    x: 361.36,
    torque: 135.98,
    y: 4.87795
  },
  {
    x: 361.96,
    torque: 136.182,
    y: 4.88709
  },
  {
    x: 362.58,
    torque: 136.41,
    y: 4.89348
  },
  {
    x: 363.2,
    torque: 136.612,
    y: 4.90354
  },
  {
    x: 363.82,
    torque: 136.814,
    y: 4.91176
  },
  {
    x: 364.44,
    torque: 136.991,
    y: 4.91907
  },
  {
    x: 365.04,
    torque: 137.244,
    y: 4.9273
  },
  {
    x: 365.66,
    torque: 137.446,
    y: 4.93461
  },
  {
    x: 366.26,
    torque: 137.649,
    y: 4.93918
  },
  {
    x: 366.86,
    torque: 137.826,
    y: 4.94923
  },
  {
    x: 367.48,
    torque: 138.053,
    y: 4.95837
  },
  {
    x: 368.08,
    torque: 138.205,
    y: 4.96385
  },
  {
    x: 368.7,
    torque: 138.382,
    y: 4.97116
  },
  {
    x: 369.32,
    torque: 138.483,
    y: 4.98121
  },
  {
    x: 369.92,
    torque: 138.685,
    y: 4.98944
  },
  {
    x: 370.52,
    torque: 138.837,
    y: 4.99675
  },
  {
    x: 371.14,
    torque: 139.09,
    y: 5.00406
  },
  {
    x: 371.74,
    torque: 139.267,
    y: 5.01045
  },
  {
    x: 372.36,
    torque: 139.494,
    y: 5.01868
  },
  {
    x: 372.98,
    torque: 139.671,
    y: 5.0269
  },
  {
    x: 373.6,
    torque: 139.874,
    y: 5.03604
  },
  {
    x: 374.22,
    torque: 140.076,
    y: 5.04426
  },
  {
    x: 374.84,
    torque: 140.253,
    y: 5.05249
  },
  {
    x: 375.46,
    torque: 140.48,
    y: 5.06071
  },
  {
    x: 376.08,
    torque: 140.657,
    y: 5.06894
  },
  {
    x: 376.68,
    torque: 140.834,
    y: 5.07808
  },
  {
    x: 377.28,
    torque: 141.037,
    y: 5.08447
  },
  {
    x: 377.88,
    torque: 141.214,
    y: 5.09361
  },
  {
    x: 378.5,
    torque: 141.441,
    y: 5.10092
  },
  {
    x: 379.12,
    torque: 141.618,
    y: 5.10732
  },
  {
    x: 379.74,
    torque: 141.82,
    y: 5.11463
  },
  {
    x: 380.34,
    torque: 141.997,
    y: 5.12194
  },
  {
    x: 380.94,
    torque: 142.2,
    y: 5.12925
  },
  {
    x: 381.54,
    torque: 142.427,
    y: 5.13839
  },
  {
    x: 382.16,
    torque: 142.604,
    y: 5.15027
  },
  {
    x: 382.78,
    torque: 142.832,
    y: 5.15849
  },
  {
    x: 383.4,
    torque: 142.984,
    y: 5.1658
  },
  {
    x: 384.02,
    torque: 143.211,
    y: 5.16946
  },
  {
    x: 384.64,
    torque: 143.388,
    y: 5.17677
  },
  {
    x: 385.24,
    torque: 143.565,
    y: 5.18408
  },
  {
    x: 385.86,
    torque: 143.767,
    y: 5.1923
  },
  {
    x: 386.46,
    torque: 143.97,
    y: 5.20144
  },
  {
    x: 387.06,
    torque: 144.147,
    y: 5.20875
  },
  {
    x: 387.68,
    torque: 144.324,
    y: 5.2188
  },
  {
    x: 388.3,
    torque: 144.526,
    y: 5.2252
  },
  {
    x: 388.92,
    torque: 144.753,
    y: 5.23708
  },
  {
    x: 389.54,
    torque: 144.981,
    y: 5.24348
  },
  {
    x: 390.16,
    torque: 145.107,
    y: 5.24805
  },
  {
    x: 390.76,
    torque: 145.31,
    y: 5.25536
  },
  {
    x: 391.36,
    torque: 145.487,
    y: 5.26358
  },
  {
    x: 391.96,
    torque: 145.664,
    y: 5.27272
  },
  {
    x: 392.58,
    torque: 145.891,
    y: 5.28094
  },
  {
    x: 393.2,
    torque: 146.068,
    y: 5.28917
  },
  {
    x: 393.82,
    torque: 146.271,
    y: 5.29739
  },
  {
    x: 394.44,
    torque: 146.473,
    y: 5.30836
  },
  {
    x: 395.04,
    torque: 146.675,
    y: 5.31384
  },
  {
    x: 395.64,
    torque: 146.852,
    y: 5.31932
  },
  {
    x: 396.26,
    torque: 147.054,
    y: 5.32572
  },
  {
    x: 396.86,
    torque: 147.282,
    y: 5.33394
  },
  {
    x: 397.48,
    torque: 147.459,
    y: 5.34308
  },
  {
    x: 398.08,
    torque: 147.636,
    y: 5.35131
  },
  {
    x: 398.7,
    torque: 147.813,
    y: 5.36045
  },
  {
    x: 399.32,
    torque: 148.04,
    y: 5.36776
  },
  {
    x: 399.92,
    torque: 148.243,
    y: 5.37689
  },
  {
    x: 400.52,
    torque: 148.394,
    y: 5.38512
  },
  {
    x: 401.14,
    torque: 148.597,
    y: 5.39243
  },
  {
    x: 401.74,
    torque: 148.799,
    y: 5.39974
  },
  {
    x: 402.36,
    torque: 149.001,
    y: 5.40614
  },
  {
    x: 402.96,
    torque: 149.204,
    y: 5.41436
  },
  {
    x: 403.58,
    torque: 149.381,
    y: 5.42441
  },
  {
    x: 404.18,
    torque: 149.583,
    y: 5.43081
  },
  {
    x: 404.78,
    torque: 149.785,
    y: 5.43538
  },
  {
    x: 405.38,
    torque: 149.962,
    y: 5.44634
  },
  {
    x: 406,
    torque: 150.164,
    y: 5.45457
  },
  {
    x: 406.62,
    torque: 150.367,
    y: 5.46279
  },
  {
    x: 407.24,
    torque: 150.594,
    y: 5.47193
  },
  {
    x: 407.86,
    torque: 150.796,
    y: 5.4765
  },
  {
    x: 408.48,
    torque: 150.973,
    y: 5.4829
  },
  {
    x: 409.1,
    torque: 151.125,
    y: 5.49203
  },
  {
    x: 409.7,
    torque: 151.277,
    y: 5.50026
  },
  {
    x: 410.32,
    torque: 151.504,
    y: 5.51122
  },
  {
    x: 410.92,
    torque: 151.681,
    y: 5.51762
  },
  {
    x: 411.52,
    torque: 151.909,
    y: 5.52493
  },
  {
    x: 412.14,
    torque: 152.111,
    y: 5.53407
  },
  {
    x: 412.76,
    torque: 152.288,
    y: 5.54138
  },
  {
    x: 413.38,
    torque: 152.516,
    y: 5.54595
  },
  {
    x: 413.98,
    torque: 152.693,
    y: 5.55783
  },
  {
    x: 414.58,
    torque: 152.92,
    y: 5.56423
  },
  {
    x: 415.18,
    torque: 153.072,
    y: 5.56971
  },
  {
    x: 415.78,
    torque: 153.249,
    y: 5.57976
  },
  {
    x: 416.4,
    torque: 153.451,
    y: 5.58616
  },
  {
    x: 417,
    torque: 153.654,
    y: 5.59073
  },
  {
    x: 417.62,
    torque: 153.856,
    y: 5.60352
  },
  {
    x: 418.22,
    torque: 154.008,
    y: 5.61266
  },
  {
    x: 418.82,
    torque: 154.235,
    y: 5.62088
  },
  {
    x: 419.44,
    torque: 154.463,
    y: 5.62819
  },
  {
    x: 420.06,
    torque: 154.64,
    y: 5.63368
  },
  {
    x: 420.68,
    torque: 154.867,
    y: 5.64099
  },
  {
    x: 421.3,
    torque: 155.07,
    y: 5.64921
  },
  {
    x: 421.92,
    torque: 155.272,
    y: 5.65652
  },
  {
    x: 422.54,
    torque: 155.449,
    y: 5.66566
  },
  {
    x: 423.16,
    torque: 155.626,
    y: 5.67663
  },
  {
    x: 423.76,
    torque: 155.828,
    y: 5.68302
  },
  {
    x: 424.36,
    torque: 156.005,
    y: 5.69033
  },
  {
    x: 424.96,
    torque: 156.233,
    y: 5.69582
  },
  {
    x: 425.56,
    torque: 156.41,
    y: 5.70404
  },
  {
    x: 426.18,
    torque: 156.662,
    y: 5.71135
  },
  {
    x: 426.8,
    torque: 156.89,
    y: 5.71957
  },
  {
    x: 427.42,
    torque: 157.067,
    y: 5.72689
  },
  {
    x: 428.02,
    torque: 157.269,
    y: 5.73511
  },
  {
    x: 428.64,
    torque: 157.446,
    y: 5.74333
  },
  {
    x: 429.24,
    torque: 157.649,
    y: 5.74973
  },
  {
    x: 429.84,
    torque: 157.826,
    y: 5.76161
  },
  {
    x: 430.46,
    torque: 158.003,
    y: 5.76892
  },
  {
    x: 431.08,
    torque: 158.18,
    y: 5.77623
  },
  {
    x: 431.7,
    torque: 158.357,
    y: 5.78354
  },
  {
    x: 432.32,
    torque: 158.584,
    y: 5.79268
  },
  {
    x: 432.92,
    torque: 158.786,
    y: 5.79816
  },
  {
    x: 433.52,
    torque: 158.989,
    y: 5.80913
  },
  {
    x: 434.12,
    torque: 159.166,
    y: 5.81187
  },
  {
    x: 434.74,
    torque: 159.368,
    y: 5.82101
  },
  {
    x: 435.36,
    torque: 159.595,
    y: 5.83015
  },
  {
    x: 435.98,
    torque: 159.772,
    y: 5.83746
  },
  {
    x: 436.6,
    torque: 160,
    y: 5.84568
  },
  {
    x: 437.22,
    torque: 160.126,
    y: 5.85665
  },
  {
    x: 437.82,
    torque: 160.354,
    y: 5.86213
  },
  {
    x: 438.42,
    torque: 160.506,
    y: 5.86853
  },
  {
    x: 439.04,
    torque: 160.708,
    y: 5.87766
  },
  {
    x: 439.64,
    torque: 160.91,
    y: 5.88223
  },
  {
    x: 440.24,
    torque: 161.087,
    y: 5.89229
  },
  {
    x: 440.86,
    torque: 161.34,
    y: 5.90051
  },
  {
    x: 441.48,
    torque: 161.492,
    y: 5.90965
  },
  {
    x: 442.1,
    torque: 161.719,
    y: 5.9197
  },
  {
    x: 442.72,
    torque: 161.896,
    y: 5.92701
  },
  {
    x: 443.32,
    torque: 162.099,
    y: 5.93432
  },
  {
    x: 443.92,
    torque: 162.276,
    y: 5.9398
  },
  {
    x: 444.52,
    torque: 162.503,
    y: 5.94986
  },
  {
    x: 445.14,
    torque: 162.655,
    y: 5.95534
  },
  {
    x: 445.76,
    torque: 162.882,
    y: 5.96356
  },
  {
    x: 446.38,
    torque: 163.11,
    y: 5.97362
  },
  {
    x: 447,
    torque: 163.312,
    y: 5.98275
  },
  {
    x: 447.6,
    torque: 163.515,
    y: 5.99189
  },
  {
    x: 448.2,
    torque: 163.717,
    y: 5.99463
  },
  {
    x: 448.8,
    torque: 163.869,
    y: 6.00469
  },
  {
    x: 449.42,
    torque: 164.121,
    y: 6.012
  },
  {
    x: 450.04,
    torque: 164.273,
    y: 6.01839
  },
  {
    x: 450.66,
    torque: 164.45,
    y: 6.02662
  },
  {
    x: 451.28,
    torque: 164.627,
    y: 6.03393
  },
  {
    x: 451.9,
    torque: 164.829,
    y: 6.04489
  },
  {
    x: 452.5,
    torque: 165.082,
    y: 6.05038
  },
  {
    x: 453.1,
    torque: 165.259,
    y: 6.05769
  },
  {
    x: 453.7,
    torque: 165.461,
    y: 6.06682
  },
  {
    x: 454.32,
    torque: 165.664,
    y: 6.07596
  },
  {
    x: 454.94,
    torque: 165.866,
    y: 6.08236
  },
  {
    x: 455.56,
    torque: 166.068,
    y: 6.08967
  },
  {
    x: 456.16,
    torque: 166.271,
    y: 6.09424
  },
  {
    x: 456.76,
    torque: 166.498,
    y: 6.10155
  },
  {
    x: 457.36,
    torque: 166.675,
    y: 6.11343
  },
  {
    x: 457.96,
    torque: 166.928,
    y: 6.12257
  },
  {
    x: 458.58,
    torque: 167.054,
    y: 6.13079
  },
  {
    x: 459.18,
    torque: 167.282,
    y: 6.1381
  },
  {
    x: 459.8,
    torque: 167.509,
    y: 6.1445
  },
  {
    x: 460.42,
    torque: 167.737,
    y: 6.15272
  },
  {
    x: 461.04,
    torque: 167.914,
    y: 6.16003
  },
  {
    x: 461.64,
    torque: 168.116,
    y: 6.16734
  },
  {
    x: 462.24,
    torque: 168.293,
    y: 6.17465
  },
  {
    x: 462.86,
    torque: 168.496,
    y: 6.18379
  },
  {
    x: 463.46,
    torque: 168.698,
    y: 6.18928
  },
  {
    x: 464.08,
    torque: 168.9,
    y: 6.20024
  },
  {
    x: 464.7,
    torque: 169.077,
    y: 6.20755
  },
  {
    x: 465.3,
    torque: 169.305,
    y: 6.21578
  },
  {
    x: 465.9,
    torque: 169.507,
    y: 6.22674
  },
  {
    x: 466.5,
    torque: 169.709,
    y: 6.23405
  },
  {
    x: 467.12,
    torque: 169.911,
    y: 6.23954
  },
  {
    x: 467.74,
    torque: 170.139,
    y: 6.24776
  },
  {
    x: 468.36,
    torque: 170.341,
    y: 6.25416
  },
  {
    x: 468.96,
    torque: 170.544,
    y: 6.26055
  },
  {
    x: 469.58,
    torque: 170.721,
    y: 6.27152
  },
  {
    x: 470.2,
    torque: 170.948,
    y: 6.27974
  },
  {
    x: 470.8,
    torque: 171.15,
    y: 6.28523
  },
  {
    x: 471.42,
    torque: 171.327,
    y: 6.29619
  },
  {
    x: 472.02,
    torque: 171.504,
    y: 6.29985
  },
  {
    x: 472.62,
    torque: 171.732,
    y: 6.31081
  },
  {
    x: 473.24,
    torque: 171.96,
    y: 6.31812
  },
  {
    x: 473.86,
    torque: 172.187,
    y: 6.32543
  },
  {
    x: 474.48,
    torque: 172.364,
    y: 6.33275
  },
  {
    x: 475.1,
    torque: 172.566,
    y: 6.34188
  },
  {
    x: 475.7,
    torque: 172.769,
    y: 6.34645
  },
  {
    x: 476.3,
    torque: 172.946,
    y: 6.35742
  },
  {
    x: 476.92,
    torque: 173.097,
    y: 6.36473
  },
  {
    x: 477.52,
    torque: 173.274,
    y: 6.37295
  },
  {
    x: 478.14,
    torque: 173.477,
    y: 6.38301
  },
  {
    x: 478.76,
    torque: 173.704,
    y: 6.39123
  },
  {
    x: 479.38,
    torque: 173.881,
    y: 6.39763
  },
  {
    x: 480,
    torque: 174.083,
    y: 6.40311
  },
  {
    x: 480.6,
    torque: 174.286,
    y: 6.40768
  },
  {
    x: 481.2,
    torque: 174.513,
    y: 6.41499
  },
  {
    x: 481.8,
    torque: 174.741,
    y: 6.42595
  },
  {
    x: 482.42,
    torque: 174.943,
    y: 6.43509
  },
  {
    x: 483.04,
    torque: 175.145,
    y: 6.44149
  },
  {
    x: 483.66,
    torque: 175.322,
    y: 6.44789
  },
  {
    x: 484.28,
    torque: 175.55,
    y: 6.45977
  },
  {
    x: 484.9,
    torque: 175.727,
    y: 6.46708
  },
  {
    x: 485.5,
    torque: 175.929,
    y: 6.47347
  },
  {
    x: 486.1,
    torque: 176.157,
    y: 6.48353
  },
  {
    x: 486.7,
    torque: 176.359,
    y: 6.48718
  },
  {
    x: 487.3,
    torque: 176.612,
    y: 6.49632
  },
  {
    x: 487.92,
    torque: 176.764,
    y: 6.50546
  },
  {
    x: 488.52,
    torque: 176.991,
    y: 6.51277
  },
  {
    x: 489.14,
    torque: 177.168,
    y: 6.52099
  },
  {
    x: 489.74,
    torque: 177.421,
    y: 6.52922
  },
  {
    x: 490.34,
    torque: 177.573,
    y: 6.53378
  },
  {
    x: 490.96,
    torque: 177.775,
    y: 6.54292
  },
  {
    x: 491.56,
    torque: 177.977,
    y: 6.55115
  },
  {
    x: 492.18,
    torque: 178.154,
    y: 6.55937
  },
  {
    x: 492.78,
    torque: 178.382,
    y: 6.5676
  },
  {
    x: 493.4,
    torque: 178.559,
    y: 6.57765
  },
  {
    x: 494,
    torque: 178.761,
    y: 6.58404
  },
  {
    x: 494.62,
    torque: 178.989,
    y: 6.58587
  },
  {
    x: 495.22,
    torque: 179.191,
    y: 6.59592
  },
  {
    x: 495.84,
    torque: 179.368,
    y: 6.6078
  },
  {
    x: 496.46,
    torque: 179.595,
    y: 6.6142
  },
  {
    x: 497.06,
    torque: 179.823,
    y: 6.62334
  },
  {
    x: 497.68,
    torque: 180,
    y: 6.62699
  },
  {
    x: 498.3,
    torque: 180.202,
    y: 6.63339
  },
  {
    x: 498.9,
    torque: 180.379,
    y: 6.64253
  },
  {
    x: 499.5,
    torque: 180.632,
    y: 6.64984
  },
  {
    x: 500.12,
    torque: 180.834,
    y: 6.65806
  },
  {
    x: 500.72,
    torque: 181.037,
    y: 6.66629
  },
  {
    x: 501.34,
    torque: 181.239,
    y: 6.67725
  },
  {
    x: 501.96,
    torque: 181.441,
    y: 6.68365
  },
  {
    x: 502.56,
    torque: 181.669,
    y: 6.69279
  },
  {
    x: 503.16,
    torque: 181.871,
    y: 6.69736
  },
  {
    x: 503.76,
    torque: 182.099,
    y: 6.70558
  },
  {
    x: 504.38,
    torque: 182.276,
    y: 6.71289
  },
  {
    x: 505,
    torque: 182.503,
    y: 6.7202
  },
  {
    x: 505.62,
    torque: 182.705,
    y: 6.72751
  },
  {
    x: 506.24,
    torque: 182.933,
    y: 6.73665
  },
  {
    x: 506.86,
    torque: 183.135,
    y: 6.74305
  },
  {
    x: 507.48,
    torque: 183.338,
    y: 6.75584
  },
  {
    x: 508.1,
    torque: 183.54,
    y: 6.76224
  },
  {
    x: 508.7,
    torque: 183.742,
    y: 6.76772
  },
  {
    x: 509.3,
    torque: 183.944,
    y: 6.77777
  },
  {
    x: 509.9,
    torque: 184.172,
    y: 6.78234
  },
  {
    x: 510.5,
    torque: 184.399,
    y: 6.79057
  },
  {
    x: 511.12,
    torque: 184.602,
    y: 6.79696
  },
  {
    x: 511.74,
    torque: 184.804,
    y: 6.80519
  },
  {
    x: 512.36,
    torque: 185.006,
    y: 6.81615
  },
  {
    x: 512.96,
    torque: 185.209,
    y: 6.82072
  },
  {
    x: 513.58,
    torque: 185.411,
    y: 6.83169
  },
  {
    x: 514.2,
    torque: 185.638,
    y: 6.83809
  },
  {
    x: 514.8,
    torque: 185.841,
    y: 6.84631
  },
  {
    x: 515.42,
    torque: 186.018,
    y: 6.85636
  },
  {
    x: 516.02,
    torque: 186.22,
    y: 6.86093
  },
  {
    x: 516.64,
    torque: 186.422,
    y: 6.87098
  },
  {
    x: 517.24,
    torque: 186.599,
    y: 6.87647
  },
  {
    x: 517.84,
    torque: 186.827,
    y: 6.8856
  },
  {
    x: 518.44,
    torque: 187.029,
    y: 6.892
  },
  {
    x: 519.06,
    torque: 187.231,
    y: 6.89931
  },
  {
    x: 519.68,
    torque: 187.408,
    y: 6.90845
  },
  {
    x: 520.28,
    torque: 187.661,
    y: 6.91667
  },
  {
    x: 520.9,
    torque: 187.838,
    y: 6.92124
  },
  {
    x: 521.52,
    torque: 188.04,
    y: 6.93129
  },
  {
    x: 522.12,
    torque: 188.243,
    y: 6.93861
  },
  {
    x: 522.74,
    torque: 188.445,
    y: 6.94683
  },
  {
    x: 523.36,
    torque: 188.698,
    y: 6.95414
  },
  {
    x: 523.96,
    torque: 188.9,
    y: 6.96419
  },
  {
    x: 524.56,
    torque: 189.077,
    y: 6.96968
  },
  {
    x: 525.18,
    torque: 189.279,
    y: 6.9779
  },
  {
    x: 525.8,
    torque: 189.532,
    y: 6.98521
  },
  {
    x: 526.42,
    torque: 189.76,
    y: 6.99435
  },
  {
    x: 527.02,
    torque: 189.987,
    y: 7.00075
  },
  {
    x: 527.62,
    torque: 190.164,
    y: 7.00531
  },
  {
    x: 528.22,
    torque: 190.392,
    y: 7.01262
  },
  {
    x: 528.84,
    torque: 190.594,
    y: 7.01994
  },
  {
    x: 529.46,
    torque: 190.796,
    y: 7.02907
  },
  {
    x: 530.06,
    torque: 190.898,
    y: 7.03912
  },
  {
    x: 530.68,
    torque: 191.125,
    y: 7.04552
  },
  {
    x: 531.28,
    torque: 191.302,
    y: 7.05375
  },
  {
    x: 531.88,
    torque: 191.53,
    y: 7.06197
  },
  {
    x: 532.48,
    torque: 191.681,
    y: 7.06928
  },
  {
    x: 533.1,
    torque: 191.96,
    y: 7.07842
  },
  {
    x: 533.72,
    torque: 192.162,
    y: 7.08664
  },
  {
    x: 534.34,
    torque: 192.389,
    y: 7.09304
  },
  {
    x: 534.96,
    torque: 192.566,
    y: 7.10218
  },
  {
    x: 535.58,
    torque: 192.769,
    y: 7.11132
  },
  {
    x: 536.18,
    torque: 192.996,
    y: 7.11771
  },
  {
    x: 536.8,
    torque: 193.224,
    y: 7.12502
  },
  {
    x: 537.4,
    torque: 193.401,
    y: 7.13325
  },
  {
    x: 538,
    torque: 193.603,
    y: 7.14239
  },
  {
    x: 538.62,
    torque: 193.78,
    y: 7.15061
  },
  {
    x: 539.24,
    torque: 194.083,
    y: 7.15883
  },
  {
    x: 539.86,
    torque: 194.26,
    y: 7.1634
  },
  {
    x: 540.46,
    torque: 194.437,
    y: 7.17254
  },
  {
    x: 541.06,
    torque: 194.614,
    y: 7.17803
  },
  {
    x: 541.66,
    torque: 194.893,
    y: 7.18899
  },
  {
    x: 542.28,
    torque: 195.07,
    y: 7.19447
  },
  {
    x: 542.9,
    torque: 195.297,
    y: 7.2027
  },
  {
    x: 543.5,
    torque: 195.424,
    y: 7.21366
  },
  {
    x: 544.12,
    torque: 195.676,
    y: 7.21915
  },
  {
    x: 544.74,
    torque: 195.904,
    y: 7.23011
  },
  {
    x: 545.36,
    torque: 196.106,
    y: 7.23468
  },
  {
    x: 545.96,
    torque: 196.359,
    y: 7.24108
  },
  {
    x: 546.56,
    torque: 196.561,
    y: 7.2493
  },
  {
    x: 547.16,
    torque: 196.839,
    y: 7.2557
  },
  {
    x: 547.78,
    torque: 197.042,
    y: 7.26575
  },
  {
    x: 548.4,
    torque: 197.269,
    y: 7.27398
  },
  {
    x: 549,
    torque: 197.446,
    y: 7.28037
  },
  {
    x: 549.62,
    torque: 197.724,
    y: 7.29225
  },
  {
    x: 550.22,
    torque: 197.876,
    y: 7.29865
  },
  {
    x: 550.82,
    torque: 198.053,
    y: 7.30596
  },
  {
    x: 551.44,
    torque: 198.255,
    y: 7.31236
  },
  {
    x: 552.04,
    torque: 198.458,
    y: 7.32058
  },
  {
    x: 552.66,
    torque: 198.711,
    y: 7.32972
  },
  {
    x: 553.28,
    torque: 198.913,
    y: 7.33794
  },
  {
    x: 553.9,
    torque: 199.09,
    y: 7.34434
  },
  {
    x: 554.52,
    torque: 199.292,
    y: 7.35713
  },
  {
    x: 555.14,
    torque: 199.494,
    y: 7.36353
  },
  {
    x: 555.74,
    torque: 199.722,
    y: 7.37084
  },
  {
    x: 556.34,
    torque: 199.899,
    y: 7.38089
  },
  {
    x: 556.94,
    torque: 200.101,
    y: 7.39003
  },
  {
    x: 557.56,
    torque: 200.278,
    y: 7.39186
  },
  {
    x: 558.18,
    torque: 200.506,
    y: 7.40282
  },
  {
    x: 558.8,
    torque: 200.708,
    y: 7.40922
  },
  {
    x: 559.42,
    torque: 200.936,
    y: 7.41836
  },
  {
    x: 560.02,
    torque: 201.113,
    y: 7.42841
  },
  {
    x: 560.64,
    torque: 201.29,
    y: 7.43755
  },
  {
    x: 561.24,
    torque: 201.492,
    y: 7.44669
  },
  {
    x: 561.86,
    torque: 201.694,
    y: 7.454
  },
  {
    x: 562.48,
    torque: 201.896,
    y: 7.46314
  },
  {
    x: 563.08,
    torque: 202.099,
    y: 7.47227
  },
  {
    x: 563.7,
    torque: 202.301,
    y: 7.47958
  },
  {
    x: 564.32,
    torque: 202.528,
    y: 7.48872
  },
  {
    x: 564.94,
    torque: 202.705,
    y: 7.49786
  },
  {
    x: 565.54,
    torque: 202.933,
    y: 7.50334
  },
  {
    x: 566.14,
    torque: 203.11,
    y: 7.51431
  },
  {
    x: 566.74,
    torque: 203.287,
    y: 7.51796
  },
  {
    x: 567.36,
    torque: 203.515,
    y: 7.53076
  },
  {
    x: 567.98,
    torque: 203.717,
    y: 7.5399
  },
  {
    x: 568.6,
    torque: 203.894,
    y: 7.54721
  },
  {
    x: 569.22,
    torque: 204.096,
    y: 7.55452
  },
  {
    x: 569.82,
    torque: 204.298,
    y: 7.56366
  },
  {
    x: 570.42,
    torque: 204.501,
    y: 7.57005
  },
  {
    x: 571.02,
    torque: 204.703,
    y: 7.5801
  },
  {
    x: 571.64,
    torque: 204.905,
    y: 7.58924
  },
  {
    x: 572.26,
    torque: 205.082,
    y: 7.59473
  },
  {
    x: 572.88,
    torque: 205.284,
    y: 7.60295
  },
  {
    x: 573.5,
    torque: 205.487,
    y: 7.61392
  },
  {
    x: 574.12,
    torque: 205.664,
    y: 7.62214
  },
  {
    x: 574.74,
    torque: 205.866,
    y: 7.63128
  },
  {
    x: 575.36,
    torque: 206.043,
    y: 7.6395
  },
  {
    x: 575.96,
    torque: 206.271,
    y: 7.64864
  },
  {
    x: 576.56,
    torque: 206.473,
    y: 7.65412
  },
  {
    x: 577.16,
    torque: 206.675,
    y: 7.66235
  },
  {
    x: 577.78,
    torque: 206.877,
    y: 7.6724
  },
  {
    x: 578.4,
    torque: 207.105,
    y: 7.68062
  },
  {
    x: 579,
    torque: 207.358,
    y: 7.68976
  },
  {
    x: 579.62,
    torque: 207.535,
    y: 7.69981
  },
  {
    x: 580.22,
    torque: 207.737,
    y: 7.70895
  },
  {
    x: 580.82,
    torque: 207.939,
    y: 7.71444
  },
  {
    x: 581.44,
    torque: 208.192,
    y: 7.7254
  },
  {
    x: 582.04,
    torque: 208.319,
    y: 7.7318
  },
  {
    x: 582.66,
    torque: 208.47,
    y: 7.73819
  },
  {
    x: 583.28,
    torque: 208.622,
    y: 7.74642
  },
  {
    x: 583.9,
    torque: 208.85,
    y: 7.75556
  },
  {
    x: 584.5,
    torque: 209.027,
    y: 7.7647
  },
  {
    x: 585.1,
    torque: 209.254,
    y: 7.77383
  },
  {
    x: 585.7,
    torque: 209.406,
    y: 7.78206
  },
  {
    x: 586.3,
    torque: 209.633,
    y: 7.7912
  },
  {
    x: 586.92,
    torque: 209.861,
    y: 7.79851
  },
  {
    x: 587.54,
    torque: 210.038,
    y: 7.80582
  },
  {
    x: 588.16,
    torque: 210.24,
    y: 7.81404
  },
  {
    x: 588.76,
    torque: 210.468,
    y: 7.82501
  },
  {
    x: 589.36,
    torque: 210.695,
    y: 7.8314
  },
  {
    x: 589.96,
    torque: 210.872,
    y: 7.84054
  },
  {
    x: 590.58,
    torque: 211.049,
    y: 7.84785
  },
  {
    x: 591.2,
    torque: 211.252,
    y: 7.85699
  },
  {
    x: 591.82,
    torque: 211.479,
    y: 7.86796
  },
  {
    x: 592.44,
    torque: 211.732,
    y: 7.87709
  },
  {
    x: 593.04,
    torque: 211.909,
    y: 7.88441
  },
  {
    x: 593.66,
    torque: 212.137,
    y: 7.88989
  },
  {
    x: 594.26,
    torque: 212.314,
    y: 7.89811
  },
  {
    x: 594.86,
    torque: 212.566,
    y: 7.90816
  },
  {
    x: 595.48,
    torque: 212.693,
    y: 7.91639
  },
  {
    x: 596.1,
    torque: 212.895,
    y: 7.92279
  },
  {
    x: 596.7,
    torque: 213.123,
    y: 7.93192
  },
  {
    x: 597.32,
    torque: 213.3,
    y: 7.94289
  },
  {
    x: 597.92,
    torque: 213.527,
    y: 7.94837
  },
  {
    x: 598.52,
    torque: 213.654,
    y: 7.95751
  },
  {
    x: 599.14,
    torque: 213.881,
    y: 7.96665
  },
  {
    x: 599.74,
    torque: 214.058,
    y: 7.97487
  },
  {
    x: 600.36,
    torque: 214.336,
    y: 7.9831
  },
  {
    x: 600.98,
    torque: 214.488,
    y: 7.99041
  },
  {
    x: 601.6,
    torque: 214.69,
    y: 7.99955
  },
  {
    x: 602.22,
    torque: 214.893,
    y: 8.00594
  },
  {
    x: 602.84,
    torque: 215.12,
    y: 8.01417
  },
  {
    x: 603.46,
    torque: 215.297,
    y: 8.02605
  },
  {
    x: 604.06,
    torque: 215.449,
    y: 8.03427
  },
  {
    x: 604.66,
    torque: 215.651,
    y: 8.0425
  },
  {
    x: 605.26,
    torque: 215.879,
    y: 8.05072
  },
  {
    x: 605.88,
    torque: 216.106,
    y: 8.05529
  },
  {
    x: 606.5,
    torque: 216.283,
    y: 8.06717
  },
  {
    x: 607.12,
    torque: 216.485,
    y: 8.07539
  },
  {
    x: 607.74,
    torque: 216.713,
    y: 8.08636
  },
  {
    x: 608.34,
    torque: 216.89,
    y: 8.09276
  },
  {
    x: 608.94,
    torque: 217.092,
    y: 8.09915
  },
  {
    x: 609.56,
    torque: 217.295,
    y: 8.10464
  },
  {
    x: 610.16,
    torque: 217.522,
    y: 8.11651
  },
  {
    x: 610.78,
    torque: 217.699,
    y: 8.12565
  },
  {
    x: 611.4,
    torque: 217.901,
    y: 8.13662
  },
  {
    x: 612.02,
    torque: 218.104,
    y: 8.14119
  },
  {
    x: 612.64,
    torque: 218.357,
    y: 8.14941
  },
  {
    x: 613.26,
    torque: 218.534,
    y: 8.15855
  },
  {
    x: 613.88,
    torque: 218.761,
    y: 8.16677
  },
  {
    x: 614.48,
    torque: 218.913,
    y: 8.17683
  },
  {
    x: 615.08,
    torque: 219.115,
    y: 8.18505
  },
  {
    x: 615.68,
    torque: 219.317,
    y: 8.19053
  },
  {
    x: 616.3,
    torque: 219.545,
    y: 8.19967
  },
  {
    x: 616.92,
    torque: 219.722,
    y: 8.21155
  },
  {
    x: 617.52,
    torque: 219.924,
    y: 8.21795
  },
  {
    x: 618.12,
    torque: 220.126,
    y: 8.22526
  },
  {
    x: 618.74,
    torque: 220.354,
    y: 8.2344
  },
  {
    x: 619.34,
    torque: 220.531,
    y: 8.23897
  },
  {
    x: 619.96,
    torque: 220.759,
    y: 8.24719
  },
  {
    x: 620.58,
    torque: 220.936,
    y: 8.25907
  },
  {
    x: 621.2,
    torque: 221.188,
    y: 8.26547
  },
  {
    x: 621.82,
    torque: 221.34,
    y: 8.27643
  },
  {
    x: 622.44,
    torque: 221.542,
    y: 8.28374
  },
  {
    x: 623.06,
    torque: 221.719,
    y: 8.29288
  },
  {
    x: 623.68,
    torque: 221.947,
    y: 8.29928
  },
  {
    x: 624.28,
    torque: 222.149,
    y: 8.3075
  },
  {
    x: 624.88,
    torque: 222.326,
    y: 8.31664
  },
  {
    x: 625.48,
    torque: 222.554,
    y: 8.32395
  },
  {
    x: 626.1,
    torque: 222.756,
    y: 8.32943
  },
  {
    x: 626.7,
    torque: 222.958,
    y: 8.33857
  },
  {
    x: 627.32,
    torque: 223.161,
    y: 8.34771
  },
  {
    x: 627.92,
    torque: 223.388,
    y: 8.35776
  },
  {
    x: 628.52,
    torque: 223.565,
    y: 8.36507
  },
  {
    x: 629.12,
    torque: 223.793,
    y: 8.37147
  },
  {
    x: 629.74,
    torque: 223.995,
    y: 8.37878
  },
  {
    x: 630.34,
    torque: 224.223,
    y: 8.38975
  },
  {
    x: 630.96,
    torque: 224.425,
    y: 8.39888
  },
  {
    x: 631.58,
    torque: 224.652,
    y: 8.40711
  },
  {
    x: 632.18,
    torque: 224.88,
    y: 8.41259
  },
  {
    x: 632.78,
    torque: 225.107,
    y: 8.42356
  },
  {
    x: 633.38,
    torque: 225.284,
    y: 8.42721
  },
  {
    x: 633.98,
    torque: 225.563,
    y: 8.43818
  },
  {
    x: 634.6,
    torque: 225.765,
    y: 8.44823
  },
  {
    x: 635.2,
    torque: 225.992,
    y: 8.4592
  },
  {
    x: 635.8,
    torque: 226.119,
    y: 8.46194
  },
  {
    x: 636.4,
    torque: 226.296,
    y: 8.47016
  },
  {
    x: 637,
    torque: 226.473,
    y: 8.48113
  },
  {
    x: 637.62,
    torque: 226.675,
    y: 8.4857
  },
  {
    x: 638.24,
    torque: 226.903,
    y: 8.49392
  },
  {
    x: 638.86,
    torque: 227.13,
    y: 8.50397
  },
  {
    x: 639.48,
    torque: 227.332,
    y: 8.51311
  },
  {
    x: 640.08,
    torque: 227.56,
    y: 8.52134
  },
  {
    x: 640.68,
    torque: 227.712,
    y: 8.52865
  },
  {
    x: 641.3,
    torque: 227.965,
    y: 8.53687
  },
  {
    x: 641.9,
    torque: 228.167,
    y: 8.54327
  },
  {
    x: 642.52,
    torque: 228.394,
    y: 8.55149
  },
  {
    x: 643.14,
    torque: 228.571,
    y: 8.56063
  },
  {
    x: 643.76,
    torque: 228.774,
    y: 8.56977
  },
  {
    x: 644.38,
    torque: 228.951,
    y: 8.57525
  },
  {
    x: 644.98,
    torque: 229.178,
    y: 8.58713
  },
  {
    x: 645.58,
    torque: 229.381,
    y: 8.59353
  },
  {
    x: 646.2,
    torque: 229.608,
    y: 8.60266
  },
  {
    x: 646.82,
    torque: 229.861,
    y: 8.61089
  },
  {
    x: 647.44,
    torque: 230.038,
    y: 8.61729
  },
  {
    x: 648.06,
    torque: 230.291,
    y: 8.62734
  },
  {
    x: 648.68,
    torque: 230.468,
    y: 8.63465
  },
  {
    x: 649.3,
    torque: 230.721,
    y: 8.64287
  },
  {
    x: 649.92,
    torque: 230.898,
    y: 8.6511
  },
  {
    x: 650.54,
    torque: 231.125,
    y: 8.65841
  },
  {
    x: 651.16,
    torque: 231.327,
    y: 8.66663
  },
  {
    x: 651.76,
    torque: 231.504,
    y: 8.67394
  },
  {
    x: 652.36,
    torque: 231.732,
    y: 8.68308
  },
  {
    x: 652.96,
    torque: 231.934,
    y: 8.69313
  },
  {
    x: 653.56,
    torque: 232.162,
    y: 8.70227
  },
  {
    x: 654.18,
    torque: 232.364,
    y: 8.70867
  },
  {
    x: 654.8,
    torque: 232.541,
    y: 8.71415
  },
  {
    x: 655.42,
    torque: 232.743,
    y: 8.72055
  },
  {
    x: 656.02,
    torque: 232.971,
    y: 8.73243
  },
  {
    x: 656.62,
    torque: 233.148,
    y: 8.73791
  },
  {
    x: 657.22,
    torque: 233.375,
    y: 8.74888
  },
  {
    x: 657.84,
    torque: 233.578,
    y: 8.7571
  },
  {
    x: 658.46,
    torque: 233.729,
    y: 8.76624
  },
  {
    x: 659.08,
    torque: 233.982,
    y: 8.77355
  },
  {
    x: 659.7,
    torque: 234.21,
    y: 8.7836
  },
  {
    x: 660.32,
    torque: 234.437,
    y: 8.78817
  },
  {
    x: 660.94,
    torque: 234.64,
    y: 8.79548
  },
  {
    x: 661.54,
    torque: 234.842,
    y: 8.80553
  },
  {
    x: 662.14,
    torque: 235.019,
    y: 8.81284
  },
  {
    x: 662.74,
    torque: 235.221,
    y: 8.82107
  },
  {
    x: 663.36,
    torque: 235.449,
    y: 8.8302
  },
  {
    x: 663.98,
    torque: 235.601,
    y: 8.84026
  },
  {
    x: 664.6,
    torque: 235.803,
    y: 8.84665
  },
  {
    x: 665.2,
    torque: 236.03,
    y: 8.85579
  },
  {
    x: 665.8,
    torque: 236.283,
    y: 8.86219
  },
  {
    x: 666.4,
    torque: 236.46,
    y: 8.86767
  },
  {
    x: 667.02,
    torque: 236.662,
    y: 8.88047
  },
  {
    x: 667.64,
    torque: 236.865,
    y: 8.88777
  },
  {
    x: 668.24,
    torque: 237.092,
    y: 8.89234
  },
  {
    x: 668.86,
    torque: 237.295,
    y: 8.90148
  },
  {
    x: 669.48,
    torque: 237.573,
    y: 8.91062
  },
  {
    x: 670.08,
    torque: 237.8,
    y: 8.92067
  },
  {
    x: 670.68,
    torque: 238.053,
    y: 8.93072
  },
  {
    x: 671.28,
    torque: 238.281,
    y: 8.93438
  },
  {
    x: 671.88,
    torque: 238.483,
    y: 8.93986
  },
  {
    x: 672.5,
    torque: 238.711,
    y: 8.949
  },
  {
    x: 673.12,
    torque: 238.963,
    y: 8.95723
  },
  {
    x: 673.72,
    torque: 239.166,
    y: 8.96454
  },
  {
    x: 674.32,
    torque: 239.368,
    y: 8.97367
  },
  {
    x: 674.94,
    torque: 239.57,
    y: 8.98281
  },
  {
    x: 675.54,
    torque: 239.747,
    y: 8.98829
  },
  {
    x: 676.16,
    torque: 239.975,
    y: 8.99835
  },
  {
    x: 676.78,
    torque: 240.202,
    y: 9.00657
  },
  {
    x: 677.4,
    torque: 240.43,
    y: 9.0148
  },
  {
    x: 678.02,
    torque: 240.632,
    y: 9.02119
  },
  {
    x: 678.64,
    torque: 240.834,
    y: 9.02668
  },
  {
    x: 679.26,
    torque: 241.062,
    y: 9.03673
  },
  {
    x: 679.86,
    torque: 241.29,
    y: 9.04495
  },
  {
    x: 680.46,
    torque: 241.517,
    y: 9.055
  },
  {
    x: 681.06,
    torque: 241.745,
    y: 9.06049
  },
  {
    x: 681.68,
    torque: 241.896,
    y: 9.07054
  },
  {
    x: 682.28,
    torque: 242.124,
    y: 9.07785
  },
  {
    x: 682.9,
    torque: 242.351,
    y: 9.08516
  },
  {
    x: 683.5,
    torque: 242.63,
    y: 9.0943
  },
  {
    x: 684.1,
    torque: 242.807,
    y: 9.10344
  },
  {
    x: 684.72,
    torque: 243.034,
    y: 9.10709
  },
  {
    x: 685.32,
    torque: 243.236,
    y: 9.11623
  },
  {
    x: 685.94,
    torque: 243.464,
    y: 9.12445
  },
  {
    x: 686.54,
    torque: 243.692,
    y: 9.13633
  },
  {
    x: 687.16,
    torque: 243.894,
    y: 9.13907
  },
  {
    x: 687.78,
    torque: 244.121,
    y: 9.15278
  },
  {
    x: 688.4,
    torque: 244.324,
    y: 9.16009
  },
  {
    x: 689,
    torque: 244.475,
    y: 9.1674
  },
  {
    x: 689.6,
    torque: 244.652,
    y: 9.17654
  },
  {
    x: 690.22,
    torque: 244.855,
    y: 9.18111
  },
  {
    x: 690.84,
    torque: 245.082,
    y: 9.18842
  },
  {
    x: 691.46,
    torque: 245.31,
    y: 9.2003
  },
  {
    x: 692.06,
    torque: 245.563,
    y: 9.20578
  },
  {
    x: 692.68,
    torque: 245.79,
    y: 9.21401
  },
  {
    x: 693.28,
    torque: 245.967,
    y: 9.21949
  },
  {
    x: 693.88,
    torque: 246.22,
    y: 9.23137
  },
  {
    x: 694.5,
    torque: 246.448,
    y: 9.24051
  },
  {
    x: 695.1,
    torque: 246.7,
    y: 9.24965
  },
  {
    x: 695.72,
    torque: 246.852,
    y: 9.2533
  },
  {
    x: 696.34,
    torque: 247.105,
    y: 9.2597
  },
  {
    x: 696.96,
    torque: 247.282,
    y: 9.26792
  },
  {
    x: 697.56,
    torque: 247.509,
    y: 9.27797
  },
  {
    x: 698.18,
    torque: 247.788,
    y: 9.28711
  },
  {
    x: 698.78,
    torque: 247.965,
    y: 9.2926
  },
  {
    x: 699.38,
    torque: 248.192,
    y: 9.30265
  },
  {
    x: 699.98,
    torque: 248.369,
    y: 9.31087
  },
  {
    x: 700.6,
    torque: 248.622,
    y: 9.3191
  },
  {
    x: 701.22,
    torque: 248.799,
    y: 9.32549
  },
  {
    x: 701.82,
    torque: 249.052,
    y: 9.33189
  },
  {
    x: 702.42,
    torque: 249.229,
    y: 9.33829
  },
  {
    x: 703.02,
    torque: 249.431,
    y: 9.34742
  },
  {
    x: 703.64,
    torque: 249.684,
    y: 9.35565
  },
  {
    x: 704.24,
    torque: 249.861,
    y: 9.36479
  },
  {
    x: 704.84,
    torque: 250.089,
    y: 9.37484
  },
  {
    x: 705.46,
    torque: 250.291,
    y: 9.38124
  },
  {
    x: 706.06,
    torque: 250.544,
    y: 9.39129
  },
  {
    x: 706.66,
    torque: 250.771,
    y: 9.3986
  },
  {
    x: 707.26,
    torque: 250.973,
    y: 9.40591
  },
  {
    x: 707.88,
    torque: 251.15,
    y: 9.41139
  },
  {
    x: 708.48,
    torque: 251.403,
    y: 9.4187
  },
  {
    x: 709.1,
    torque: 251.606,
    y: 9.42875
  },
  {
    x: 709.7,
    torque: 251.858,
    y: 9.43515
  },
  {
    x: 710.3,
    torque: 252.01,
    y: 9.44246
  },
  {
    x: 710.9,
    torque: 252.238,
    y: 9.45251
  },
  {
    x: 711.5,
    torque: 252.465,
    y: 9.46165
  },
  {
    x: 712.12,
    torque: 252.718,
    y: 9.47079
  },
  {
    x: 712.74,
    torque: 252.895,
    y: 9.47993
  },
  {
    x: 713.36,
    torque: 253.123,
    y: 9.48632
  },
  {
    x: 713.98,
    torque: 253.35,
    y: 9.49272
  },
  {
    x: 714.58,
    torque: 253.578,
    y: 9.50186
  },
  {
    x: 715.18,
    torque: 253.78,
    y: 9.50734
  },
  {
    x: 715.8,
    torque: 254.033,
    y: 9.51739
  },
  {
    x: 716.42,
    torque: 254.21,
    y: 9.52379
  },
  {
    x: 717.02,
    torque: 254.463,
    y: 9.53384
  },
  {
    x: 717.64,
    torque: 254.665,
    y: 9.53933
  },
  {
    x: 718.24,
    torque: 254.918,
    y: 9.54938
  },
  {
    x: 718.84,
    torque: 255.12,
    y: 9.55852
  },
  {
    x: 719.46,
    torque: 255.322,
    y: 9.564
  },
  {
    x: 720.08,
    torque: 255.575,
    y: 9.57131
  },
  {
    x: 720.7,
    torque: 255.778,
    y: 9.57771
  },
  {
    x: 721.3,
    torque: 256.005,
    y: 9.58684
  },
  {
    x: 721.92,
    torque: 256.207,
    y: 9.5969
  },
  {
    x: 722.54,
    torque: 256.46,
    y: 9.60329
  },
  {
    x: 723.16,
    torque: 256.688,
    y: 9.61152
  },
  {
    x: 723.78,
    torque: 256.941,
    y: 9.61791
  },
  {
    x: 724.4,
    torque: 257.143,
    y: 9.62888
  },
  {
    x: 725,
    torque: 257.396,
    y: 9.63528
  },
  {
    x: 725.6,
    torque: 257.547,
    y: 9.64259
  },
  {
    x: 726.2,
    torque: 257.8,
    y: 9.64807
  },
  {
    x: 726.82,
    torque: 258.003,
    y: 9.65538
  },
  {
    x: 727.44,
    torque: 258.255,
    y: 9.6636
  },
  {
    x: 728.04,
    torque: 258.458,
    y: 9.67366
  },
  {
    x: 728.64,
    torque: 258.635,
    y: 9.6828
  },
  {
    x: 729.24,
    torque: 258.887,
    y: 9.68736
  },
  {
    x: 729.84,
    torque: 259.09,
    y: 9.69376
  },
  {
    x: 730.46,
    torque: 259.343,
    y: 9.7029
  },
  {
    x: 731.08,
    torque: 259.494,
    y: 9.71112
  },
  {
    x: 731.7,
    torque: 259.772,
    y: 9.71843
  },
  {
    x: 732.32,
    torque: 259.975,
    y: 9.72849
  },
  {
    x: 732.94,
    torque: 260.228,
    y: 9.73488
  },
  {
    x: 733.56,
    torque: 260.43,
    y: 9.74311
  },
  {
    x: 734.16,
    torque: 260.632,
    y: 9.75133
  },
  {
    x: 734.76,
    torque: 260.885,
    y: 9.7559
  },
  {
    x: 735.38,
    torque: 261.138,
    y: 9.76778
  },
  {
    x: 736,
    torque: 261.34,
    y: 9.77692
  },
  {
    x: 736.62,
    torque: 261.542,
    y: 9.78331
  },
  {
    x: 737.24,
    torque: 261.82,
    y: 9.7888
  },
  {
    x: 737.86,
    torque: 262.048,
    y: 9.79611
  },
  {
    x: 738.48,
    torque: 262.301,
    y: 9.8089
  },
  {
    x: 739.1,
    torque: 262.503,
    y: 9.81347
  },
  {
    x: 739.7,
    torque: 262.756,
    y: 9.82261
  },
  {
    x: 740.3,
    torque: 262.958,
    y: 9.82992
  },
  {
    x: 740.92,
    torque: 263.11,
    y: 9.8354
  },
  {
    x: 741.52,
    torque: 263.312,
    y: 9.84363
  },
  {
    x: 742.14,
    torque: 263.515,
    y: 9.85368
  },
  {
    x: 742.76,
    torque: 263.742,
    y: 9.86282
  },
  {
    x: 743.38,
    torque: 263.97,
    y: 9.87104
  },
  {
    x: 744,
    torque: 264.223,
    y: 9.87561
  },
  {
    x: 744.6,
    torque: 264.45,
    y: 9.88383
  },
  {
    x: 745.2,
    torque: 264.678,
    y: 9.89297
  },
  {
    x: 745.8,
    torque: 264.88,
    y: 9.9012
  },
  {
    x: 746.42,
    torque: 265.133,
    y: 9.90851
  },
  {
    x: 747.02,
    torque: 265.335,
    y: 9.9149
  },
  {
    x: 747.64,
    torque: 265.537,
    y: 9.92496
  },
  {
    x: 748.26,
    torque: 265.765,
    y: 9.92953
  },
  {
    x: 748.86,
    torque: 265.967,
    y: 9.94049
  },
  {
    x: 749.46,
    torque: 266.195,
    y: 9.94597
  },
  {
    x: 750.08,
    torque: 266.448,
    y: 9.95329
  },
  {
    x: 750.7,
    torque: 266.65,
    y: 9.95877
  },
  {
    x: 751.3,
    torque: 266.903,
    y: 9.96973
  },
  {
    x: 751.92,
    torque: 267.105,
    y: 9.97522
  },
  {
    x: 752.54,
    torque: 267.358,
    y: 9.9871
  },
  {
    x: 753.16,
    torque: 267.56,
    y: 9.99441
  },
  {
    x: 753.78,
    torque: 267.788,
    y: 9.99989
  },
  {
    x: 754.38,
    torque: 267.965,
    y: 10.0081
  },
  {
    x: 754.98,
    torque: 268.192,
    y: 10.0145
  },
  {
    x: 755.58,
    torque: 268.445,
    y: 10.0218
  },
  {
    x: 756.2,
    torque: 268.622,
    y: 10.03
  },
  {
    x: 756.82,
    torque: 268.9,
    y: 10.0364
  },
  {
    x: 757.44,
    torque: 269.077,
    y: 10.0474
  },
  {
    x: 758.06,
    torque: 269.381,
    y: 10.0538
  },
  {
    x: 758.66,
    torque: 269.558,
    y: 10.0639
  },
  {
    x: 759.26,
    torque: 269.785,
    y: 10.0703
  },
  {
    x: 759.86,
    torque: 269.987,
    y: 10.0766
  },
  {
    x: 760.48,
    torque: 270.265,
    y: 10.084
  },
  {
    x: 761.08,
    torque: 270.442,
    y: 10.094
  },
  {
    x: 761.7,
    torque: 270.67,
    y: 10.0995
  },
  {
    x: 762.32,
    torque: 270.898,
    y: 10.1077
  },
  {
    x: 762.94,
    torque: 271.15,
    y: 10.1141
  },
  {
    x: 763.54,
    torque: 271.429,
    y: 10.1233
  },
  {
    x: 764.14,
    torque: 271.631,
    y: 10.1306
  },
  {
    x: 764.74,
    torque: 271.833,
    y: 10.1379
  },
  {
    x: 765.36,
    torque: 272.086,
    y: 10.1488
  },
  {
    x: 765.98,
    torque: 272.314,
    y: 10.158
  },
  {
    x: 766.6,
    torque: 272.541,
    y: 10.1662
  },
  {
    x: 767.22,
    torque: 272.769,
    y: 10.1699
  },
  {
    x: 767.82,
    torque: 272.996,
    y: 10.1781
  },
  {
    x: 768.42,
    torque: 273.224,
    y: 10.1863
  },
  {
    x: 769.02,
    torque: 273.451,
    y: 10.1936
  },
  {
    x: 769.64,
    torque: 273.679,
    y: 10.2018
  },
  {
    x: 770.26,
    torque: 273.932,
    y: 10.2092
  },
  {
    x: 770.86,
    torque: 274.185,
    y: 10.2137
  },
  {
    x: 771.48,
    torque: 274.362,
    y: 10.2229
  },
  {
    x: 772.1,
    torque: 274.589,
    y: 10.2347
  },
  {
    x: 772.7,
    torque: 274.817,
    y: 10.2411
  },
  {
    x: 773.3,
    torque: 275.07,
    y: 10.2494
  },
  {
    x: 773.92,
    torque: 275.272,
    y: 10.2548
  },
  {
    x: 774.52,
    torque: 275.499,
    y: 10.2594
  },
  {
    x: 775.14,
    torque: 275.702,
    y: 10.2704
  },
  {
    x: 775.76,
    torque: 275.929,
    y: 10.2768
  },
  {
    x: 776.38,
    torque: 276.182,
    y: 10.2841
  },
  {
    x: 776.98,
    torque: 276.384,
    y: 10.2905
  },
  {
    x: 777.58,
    torque: 276.587,
    y: 10.2996
  },
  {
    x: 778.2,
    torque: 276.814,
    y: 10.3051
  },
  {
    x: 778.8,
    torque: 277.016,
    y: 10.3161
  },
  {
    x: 779.42,
    torque: 277.269,
    y: 10.3234
  },
  {
    x: 780.04,
    torque: 277.472,
    y: 10.3307
  },
  {
    x: 780.66,
    torque: 277.699,
    y: 10.3371
  },
  {
    x: 781.28,
    torque: 277.927,
    y: 10.3453
  },
  {
    x: 781.9,
    torque: 278.154,
    y: 10.3544
  },
  {
    x: 782.5,
    torque: 278.382,
    y: 10.3618
  },
  {
    x: 783.1,
    torque: 278.609,
    y: 10.3663
  },
  {
    x: 783.7,
    torque: 278.837,
    y: 10.3755
  },
  {
    x: 784.3,
    torque: 279.064,
    y: 10.3837
  },
  {
    x: 784.92,
    torque: 279.292,
    y: 10.391
  },
  {
    x: 785.54,
    torque: 279.52,
    y: 10.3992
  },
  {
    x: 786.14,
    torque: 279.722,
    y: 10.4038
  },
  {
    x: 786.74,
    torque: 279.949,
    y: 10.4111
  },
  {
    x: 787.34,
    torque: 280.177,
    y: 10.4175
  },
  {
    x: 787.94,
    torque: 280.379,
    y: 10.4276
  },
  {
    x: 788.56,
    torque: 280.683,
    y: 10.434
  },
  {
    x: 789.18,
    torque: 280.936,
    y: 10.4422
  },
  {
    x: 789.78,
    torque: 281.087,
    y: 10.4513
  },
  {
    x: 790.4,
    torque: 281.34,
    y: 10.4595
  },
  {
    x: 791,
    torque: 281.593,
    y: 10.465
  },
  {
    x: 791.6,
    torque: 281.871,
    y: 10.4723
  },
  {
    x: 792.22,
    torque: 282.048,
    y: 10.4815
  },
  {
    x: 792.84,
    torque: 282.2,
    y: 10.486
  },
  {
    x: 793.46,
    torque: 282.377,
    y: 10.4924
  },
  {
    x: 794.08,
    torque: 282.604,
    y: 10.4997
  },
  {
    x: 794.7,
    torque: 282.857,
    y: 10.5098
  },
  {
    x: 795.3,
    torque: 283.034,
    y: 10.518
  },
  {
    x: 795.9,
    torque: 283.262,
    y: 10.5272
  },
  {
    x: 796.5,
    torque: 283.489,
    y: 10.5326
  },
  {
    x: 797.12,
    torque: 283.742,
    y: 10.5409
  },
  {
    x: 797.74,
    torque: 283.97,
    y: 10.5464
  },
  {
    x: 798.36,
    torque: 284.223,
    y: 10.5546
  },
  {
    x: 798.96,
    torque: 284.45,
    y: 10.5637
  },
  {
    x: 799.58,
    torque: 284.652,
    y: 10.571
  },
  {
    x: 800.2,
    torque: 284.88,
    y: 10.5765
  },
  {
    x: 800.8,
    torque: 285.107,
    y: 10.5847
  },
  {
    x: 801.42,
    torque: 285.36,
    y: 10.593
  },
  {
    x: 802.02,
    torque: 285.638,
    y: 10.6048
  },
  {
    x: 802.62,
    torque: 285.866,
    y: 10.6131
  },
  {
    x: 803.24,
    torque: 286.119,
    y: 10.6176
  },
  {
    x: 803.86,
    torque: 286.372,
    y: 10.624
  },
  {
    x: 804.48,
    torque: 286.65,
    y: 10.6323
  },
  {
    x: 805.08,
    torque: 286.827,
    y: 10.6405
  },
  {
    x: 805.68,
    torque: 287.105,
    y: 10.6487
  },
  {
    x: 806.3,
    torque: 287.282,
    y: 10.656
  },
  {
    x: 806.92,
    torque: 287.56,
    y: 10.6633
  },
  {
    x: 807.52,
    torque: 287.737,
    y: 10.6706
  },
  {
    x: 808.14,
    torque: 287.939,
    y: 10.6807
  },
  {
    x: 808.76,
    torque: 288.167,
    y: 10.6862
  },
  {
    x: 809.38,
    torque: 288.445,
    y: 10.6953
  },
  {
    x: 810,
    torque: 288.673,
    y: 10.6999
  },
  {
    x: 810.6,
    torque: 288.875,
    y: 10.7063
  },
  {
    x: 811.2,
    torque: 289.102,
    y: 10.7145
  },
  {
    x: 811.8,
    torque: 289.355,
    y: 10.7218
  },
  {
    x: 812.42,
    torque: 289.583,
    y: 10.7309
  },
  {
    x: 813.04,
    torque: 289.785,
    y: 10.7373
  },
  {
    x: 813.66,
    torque: 290.038,
    y: 10.7446
  },
  {
    x: 814.26,
    torque: 290.24,
    y: 10.751
  },
  {
    x: 814.86,
    torque: 290.493,
    y: 10.762
  },
  {
    x: 815.46,
    torque: 290.695,
    y: 10.7702
  },
  {
    x: 816.08,
    torque: 290.948,
    y: 10.7766
  },
  {
    x: 816.7,
    torque: 291.176,
    y: 10.783
  },
  {
    x: 817.32,
    torque: 291.403,
    y: 10.7913
  },
  {
    x: 817.92,
    torque: 291.606,
    y: 10.7986
  },
  {
    x: 818.54,
    torque: 291.858,
    y: 10.8068
  },
  {
    x: 819.16,
    torque: 292.111,
    y: 10.8123
  },
  {
    x: 819.76,
    torque: 292.314,
    y: 10.8196
  },
  {
    x: 820.36,
    torque: 292.516,
    y: 10.8278
  },
  {
    x: 820.96,
    torque: 292.743,
    y: 10.8351
  },
  {
    x: 821.58,
    torque: 293.021,
    y: 10.8433
  },
  {
    x: 822.18,
    torque: 293.224,
    y: 10.8479
  },
  {
    x: 822.8,
    torque: 293.426,
    y: 10.8552
  },
  {
    x: 823.42,
    torque: 293.603,
    y: 10.8634
  },
  {
    x: 824.02,
    torque: 293.856,
    y: 10.8726
  },
  {
    x: 824.62,
    torque: 294.109,
    y: 10.8799
  },
  {
    x: 825.24,
    torque: 294.387,
    y: 10.889
  },
  {
    x: 825.86,
    torque: 294.589,
    y: 10.8973
  },
  {
    x: 826.46,
    torque: 294.817,
    y: 10.9027
  },
  {
    x: 827.08,
    torque: 295.044,
    y: 10.9091
  },
  {
    x: 827.7,
    torque: 295.272,
    y: 10.9183
  },
  {
    x: 828.32,
    torque: 295.525,
    y: 10.9247
  },
  {
    x: 828.92,
    torque: 295.752,
    y: 10.9347
  },
  {
    x: 829.52,
    torque: 295.98,
    y: 10.9375
  },
  {
    x: 830.12,
    torque: 296.182,
    y: 10.9457
  },
  {
    x: 830.72,
    torque: 296.41,
    y: 10.9539
  },
  {
    x: 831.34,
    torque: 296.637,
    y: 10.9585
  },
  {
    x: 831.96,
    torque: 296.865,
    y: 10.9704
  },
  {
    x: 832.56,
    torque: 297.092,
    y: 10.9768
  },
  {
    x: 833.16,
    torque: 297.295,
    y: 10.9859
  },
  {
    x: 833.76,
    torque: 297.547,
    y: 10.9896
  },
  {
    x: 834.38,
    torque: 297.75,
    y: 10.9969
  },
  {
    x: 834.98,
    torque: 298.028,
    y: 11.006
  },
  {
    x: 835.6,
    torque: 298.23,
    y: 11.0124
  },
  {
    x: 836.22,
    torque: 298.483,
    y: 11.0188
  },
  {
    x: 836.84,
    torque: 298.71,
    y: 11.027
  },
  {
    x: 837.44,
    torque: 298.963,
    y: 11.0371
  },
  {
    x: 838.04,
    torque: 299.216,
    y: 11.0426
  },
  {
    x: 838.64,
    torque: 299.418,
    y: 11.049
  },
  {
    x: 839.26,
    torque: 299.671,
    y: 11.0544
  },
  {
    x: 839.86,
    torque: 299.899,
    y: 11.0608
  },
  {
    x: 840.48,
    torque: 300.152,
    y: 11.0691
  },
  {
    x: 841.08,
    torque: 300.405,
    y: 11.0764
  },
  {
    x: 841.68,
    torque: 300.607,
    y: 11.0855
  },
  {
    x: 842.3,
    torque: 300.834,
    y: 11.0892
  },
  {
    x: 842.92,
    torque: 301.087,
    y: 11.1001
  },
  {
    x: 843.52,
    torque: 301.315,
    y: 11.1065
  },
  {
    x: 844.14,
    torque: 301.467,
    y: 11.1147
  },
  {
    x: 844.76,
    torque: 301.669,
    y: 11.1248
  },
  {
    x: 845.38,
    torque: 301.871,
    y: 11.1312
  },
  {
    x: 846,
    torque: 302.124,
    y: 11.1376
  },
  {
    x: 846.62,
    torque: 302.377,
    y: 11.1431
  },
  {
    x: 847.22,
    torque: 302.604,
    y: 11.1513
  },
  {
    x: 847.82,
    torque: 302.857,
    y: 11.1586
  },
  {
    x: 848.42,
    torque: 303.059,
    y: 11.1668
  },
  {
    x: 849.04,
    torque: 303.312,
    y: 11.1723
  },
  {
    x: 849.66,
    torque: 303.54,
    y: 11.1805
  },
  {
    x: 850.26,
    torque: 303.843,
    y: 11.1897
  },
  {
    x: 850.86,
    torque: 304.02,
    y: 11.1961
  },
  {
    x: 851.46,
    torque: 304.248,
    y: 11.2052
  },
  {
    x: 852.06,
    torque: 304.45,
    y: 11.2098
  },
  {
    x: 852.68,
    torque: 304.703,
    y: 11.2162
  },
  {
    x: 853.3,
    torque: 304.981,
    y: 11.2226
  },
  {
    x: 853.92,
    torque: 305.209,
    y: 11.2317
  },
  {
    x: 854.54,
    torque: 305.487,
    y: 11.2399
  },
  {
    x: 855.16,
    torque: 305.714,
    y: 11.2472
  },
  {
    x: 855.76,
    torque: 305.967,
    y: 11.2536
  },
  {
    x: 856.36,
    torque: 306.144,
    y: 11.2628
  },
  {
    x: 856.96,
    torque: 306.372,
    y: 11.271
  },
  {
    x: 857.58,
    torque: 306.599,
    y: 11.2765
  },
  {
    x: 858.2,
    torque: 306.852,
    y: 11.282
  },
  {
    x: 858.82,
    torque: 307.105,
    y: 11.2884
  },
  {
    x: 859.44,
    torque: 307.282,
    y: 11.3012
  },
  {
    x: 860.04,
    torque: 307.535,
    y: 11.3039
  },
  {
    x: 860.64,
    torque: 307.762,
    y: 11.314
  },
  {
    x: 861.24,
    torque: 308.04,
    y: 11.3222
  },
  {
    x: 861.86,
    torque: 308.268,
    y: 11.3304
  },
  {
    x: 862.48,
    torque: 308.496,
    y: 11.3368
  },
  {
    x: 863.08,
    torque: 308.774,
    y: 11.345
  },
  {
    x: 863.7,
    torque: 308.951,
    y: 11.3505
  },
  {
    x: 864.32,
    torque: 309.153,
    y: 11.3587
  },
  {
    x: 864.94,
    torque: 309.355,
    y: 11.3624
  },
  {
    x: 865.54,
    torque: 309.608,
    y: 11.3697
  },
  {
    x: 866.14,
    torque: 309.836,
    y: 11.3798
  },
  {
    x: 866.74,
    torque: 310.088,
    y: 11.3852
  },
  {
    x: 867.36,
    torque: 310.341,
    y: 11.3925
  },
  {
    x: 867.98,
    torque: 310.594,
    y: 11.4008
  },
  {
    x: 868.58,
    torque: 310.796,
    y: 11.4081
  },
  {
    x: 869.2,
    torque: 311.049,
    y: 11.4181
  },
  {
    x: 869.8,
    torque: 311.252,
    y: 11.4236
  },
  {
    x: 870.42,
    torque: 311.504,
    y: 11.4291
  },
  {
    x: 871.02,
    torque: 311.707,
    y: 11.4373
  },
  {
    x: 871.64,
    torque: 311.934,
    y: 11.4419
  },
  {
    x: 872.26,
    torque: 312.162,
    y: 11.4465
  },
  {
    x: 872.88,
    torque: 312.44,
    y: 11.4565
  },
  {
    x: 873.48,
    torque: 312.668,
    y: 11.4675
  },
  {
    x: 874.1,
    torque: 312.895,
    y: 11.4739
  },
  {
    x: 874.72,
    torque: 313.072,
    y: 11.483
  },
  {
    x: 875.32,
    torque: 313.325,
    y: 11.4867
  },
  {
    x: 875.92,
    torque: 313.578,
    y: 11.494
  },
  {
    x: 876.52,
    torque: 313.805,
    y: 11.5004
  },
  {
    x: 877.14,
    torque: 314.033,
    y: 11.5068
  },
  {
    x: 877.74,
    torque: 314.286,
    y: 11.5132
  },
  {
    x: 878.34,
    torque: 314.513,
    y: 11.5214
  },
  {
    x: 878.94,
    torque: 314.716,
    y: 11.525
  },
  {
    x: 879.56,
    torque: 314.994,
    y: 11.5378
  },
  {
    x: 880.18,
    torque: 315.196,
    y: 11.5461
  },
  {
    x: 880.8,
    torque: 315.474,
    y: 11.5515
  },
  {
    x: 881.42,
    torque: 315.676,
    y: 11.557
  },
  {
    x: 882.04,
    torque: 315.904,
    y: 11.5662
  },
  {
    x: 882.64,
    torque: 316.131,
    y: 11.5726
  },
  {
    x: 883.26,
    torque: 316.359,
    y: 11.5771
  },
  {
    x: 883.88,
    torque: 316.587,
    y: 11.5872
  },
  {
    x: 884.48,
    torque: 316.814,
    y: 11.5936
  },
  {
    x: 885.08,
    torque: 317.092,
    y: 11.6009
  },
  {
    x: 885.68,
    torque: 317.295,
    y: 11.6109
  },
  {
    x: 886.28,
    torque: 317.573,
    y: 11.6192
  },
  {
    x: 886.9,
    torque: 317.75,
    y: 11.6228
  },
  {
    x: 887.5,
    torque: 318.028,
    y: 11.6301
  },
  {
    x: 888.1,
    torque: 318.23,
    y: 11.6365
  },
  {
    x: 888.72,
    torque: 318.483,
    y: 11.6438
  },
  {
    x: 889.34,
    torque: 318.685,
    y: 11.6521
  },
  {
    x: 889.94,
    torque: 318.938,
    y: 11.6594
  },
  {
    x: 890.54,
    torque: 319.166,
    y: 11.6649
  },
  {
    x: 891.16,
    torque: 319.444,
    y: 11.6713
  },
  {
    x: 891.78,
    torque: 319.722,
    y: 11.6822
  },
  {
    x: 892.38,
    torque: 319.924,
    y: 11.6886
  },
  {
    x: 892.98,
    torque: 320.202,
    y: 11.6978
  },
  {
    x: 893.6,
    torque: 320.405,
    y: 11.7005
  },
  {
    x: 894.2,
    torque: 320.683,
    y: 11.7069
  },
  {
    x: 894.82,
    torque: 320.91,
    y: 11.716
  },
  {
    x: 895.44,
    torque: 321.062,
    y: 11.7243
  },
  {
    x: 896.04,
    torque: 321.29,
    y: 11.7288
  },
  {
    x: 896.64,
    torque: 321.492,
    y: 11.7371
  },
  {
    x: 897.26,
    torque: 321.745,
    y: 11.7444
  },
  {
    x: 897.88,
    torque: 321.997,
    y: 11.7498
  },
  {
    x: 898.48,
    torque: 322.25,
    y: 11.759
  },
  {
    x: 899.1,
    torque: 322.503,
    y: 11.7663
  },
  {
    x: 899.72,
    torque: 322.705,
    y: 11.7745
  },
  {
    x: 900.32,
    torque: 323.009,
    y: 11.7773
  },
  {
    x: 900.94,
    torque: 323.236,
    y: 11.7855
  },
  {
    x: 901.54,
    torque: 323.489,
    y: 11.7928
  },
  {
    x: 902.14,
    torque: 323.692,
    y: 11.8019
  },
  {
    x: 902.74,
    torque: 323.919,
    y: 11.8074
  },
  {
    x: 903.36,
    torque: 324.147,
    y: 11.8156
  },
  {
    x: 903.98,
    torque: 324.374,
    y: 11.8239
  },
  {
    x: 904.6,
    torque: 324.652,
    y: 11.8321
  },
  {
    x: 905.2,
    torque: 324.855,
    y: 11.8357
  },
  {
    x: 905.8,
    torque: 325.133,
    y: 11.8467
  },
  {
    x: 906.42,
    torque: 325.36,
    y: 11.8513
  },
  {
    x: 907.02,
    torque: 325.638,
    y: 11.8586
  },
  {
    x: 907.64,
    torque: 325.815,
    y: 11.8677
  },
  {
    x: 908.24,
    torque: 326.094,
    y: 11.8732
  },
  {
    x: 908.86,
    torque: 326.271,
    y: 11.8824
  },
  {
    x: 909.48,
    torque: 326.549,
    y: 11.8887
  },
  {
    x: 910.1,
    torque: 326.751,
    y: 11.8979
  },
  {
    x: 910.72,
    torque: 327.004,
    y: 11.9043
  },
  {
    x: 911.32,
    torque: 327.206,
    y: 11.9125
  },
  {
    x: 911.92,
    torque: 327.434,
    y: 11.9152
  },
  {
    x: 912.52,
    torque: 327.661,
    y: 11.9226
  },
  {
    x: 913.14,
    torque: 327.889,
    y: 11.9308
  },
  {
    x: 913.76,
    torque: 328.142,
    y: 11.9372
  },
  {
    x: 914.38,
    torque: 328.394,
    y: 11.9481
  },
  {
    x: 915,
    torque: 328.622,
    y: 11.9545
  },
  {
    x: 915.62,
    torque: 328.824,
    y: 11.96
  },
  {
    x: 916.22,
    torque: 329.052,
    y: 11.9701
  },
  {
    x: 916.82,
    torque: 329.279,
    y: 11.9756
  },
  {
    x: 917.44,
    torque: 329.532,
    y: 11.982
  },
  {
    x: 918.06,
    torque: 329.76,
    y: 11.9902
  },
  {
    x: 918.68,
    torque: 329.987,
    y: 11.9975
  },
  {
    x: 919.28,
    torque: 330.24,
    y: 12.0057
  },
  {
    x: 919.9,
    torque: 330.468,
    y: 12.0094
  },
  {
    x: 920.5,
    torque: 330.746,
    y: 12.0185
  },
  {
    x: 921.1,
    torque: 330.973,
    y: 12.0258
  },
  {
    x: 921.7,
    torque: 331.201,
    y: 12.0331
  },
  {
    x: 922.3,
    torque: 331.403,
    y: 12.0395
  },
  {
    x: 922.92,
    torque: 331.656,
    y: 12.0478
  },
  {
    x: 923.54,
    torque: 331.909,
    y: 12.0541
  },
  {
    x: 924.16,
    torque: 332.111,
    y: 12.0624
  },
  {
    x: 924.76,
    torque: 332.364,
    y: 12.0669
  },
  {
    x: 925.36,
    torque: 332.566,
    y: 12.0743
  },
  {
    x: 925.98,
    torque: 332.87,
    y: 12.0843
  },
  {
    x: 926.6,
    torque: 333.072,
    y: 12.0907
  },
  {
    x: 927.2,
    torque: 333.325,
    y: 12.0971
  },
  {
    x: 927.82,
    torque: 333.552,
    y: 12.1062
  },
  {
    x: 928.44,
    torque: 333.831,
    y: 12.1117
  },
  {
    x: 929.04,
    torque: 334.083,
    y: 12.119
  },
  {
    x: 929.64,
    torque: 334.311,
    y: 12.1263
  },
  {
    x: 930.24,
    torque: 334.539,
    y: 12.1318
  },
  {
    x: 930.86,
    torque: 334.791,
    y: 12.1382
  },
  {
    x: 931.48,
    torque: 334.968,
    y: 12.1474
  },
  {
    x: 932.1,
    torque: 335.247,
    y: 12.1501
  },
  {
    x: 932.7,
    torque: 335.424,
    y: 12.1602
  },
  {
    x: 933.32,
    torque: 335.676,
    y: 12.1675
  },
  {
    x: 933.92,
    torque: 335.853,
    y: 12.1766
  },
  {
    x: 934.52,
    torque: 336.106,
    y: 12.1803
  },
  {
    x: 935.14,
    torque: 336.334,
    y: 12.1857
  },
  {
    x: 935.74,
    torque: 336.612,
    y: 12.193
  },
  {
    x: 936.36,
    torque: 336.839,
    y: 12.2022
  },
  {
    x: 936.98,
    torque: 337.067,
    y: 12.2104
  },
  {
    x: 937.6,
    torque: 337.295,
    y: 12.2168
  },
  {
    x: 938.22,
    torque: 337.573,
    y: 12.2241
  },
  {
    x: 938.82,
    torque: 337.8,
    y: 12.2305
  },
  {
    x: 939.42,
    torque: 338.078,
    y: 12.2387
  },
  {
    x: 940.02,
    torque: 338.331,
    y: 12.246
  },
  {
    x: 940.62,
    torque: 338.584,
    y: 12.2524
  },
  {
    x: 941.24,
    torque: 338.837,
    y: 12.2598
  },
  {
    x: 941.86,
    torque: 339.064,
    y: 12.2662
  },
  {
    x: 942.48,
    torque: 339.343,
    y: 12.2762
  },
  {
    x: 943.1,
    torque: 339.646,
    y: 12.2808
  },
  {
    x: 943.7,
    torque: 339.874,
    y: 12.2908
  },
  {
    x: 944.3,
    torque: 340.076,
    y: 12.2954
  },
  {
    x: 944.92,
    torque: 340.329,
    y: 12.3027
  },
  {
    x: 945.52,
    torque: 340.531,
    y: 12.3118
  },
  {
    x: 946.14,
    torque: 340.759,
    y: 12.3228
  },
  {
    x: 946.76,
    torque: 340.936,
    y: 12.3274
  },
  {
    x: 947.38,
    torque: 341.188,
    y: 12.3329
  },
  {
    x: 948,
    torque: 341.416,
    y: 12.3383
  },
  {
    x: 948.62,
    torque: 341.643,
    y: 12.3457
  },
  {
    x: 949.22,
    torque: 341.871,
    y: 12.353
  },
  {
    x: 949.82,
    torque: 342.149,
    y: 12.3612
  },
  {
    x: 950.44,
    torque: 342.402,
    y: 12.3685
  },
  {
    x: 951.04,
    torque: 342.655,
    y: 12.3731
  },
  {
    x: 951.66,
    torque: 342.882,
    y: 12.3859
  },
  {
    x: 952.28,
    torque: 343.11,
    y: 12.3895
  },
  {
    x: 952.9,
    torque: 343.338,
    y: 12.3977
  },
  {
    x: 953.5,
    torque: 343.565,
    y: 12.4032
  },
  {
    x: 954.1,
    torque: 343.818,
    y: 12.4105
  },
  {
    x: 954.7,
    torque: 344.046,
    y: 12.4197
  },
  {
    x: 955.3,
    torque: 344.324,
    y: 12.4233
  },
  {
    x: 955.92,
    torque: 344.526,
    y: 12.4316
  },
  {
    x: 956.54,
    torque: 344.804,
    y: 12.438
  },
  {
    x: 957.16,
    torque: 345.006,
    y: 12.4443
  },
  {
    x: 957.78,
    torque: 345.259,
    y: 12.4517
  },
  {
    x: 958.38,
    torque: 345.461,
    y: 12.4617
  },
  {
    x: 958.98,
    torque: 345.714,
    y: 12.4681
  },
  {
    x: 959.6,
    torque: 345.917,
    y: 12.4736
  },
  {
    x: 960.2,
    torque: 346.169,
    y: 12.4782
  },
  {
    x: 960.82,
    torque: 346.397,
    y: 12.4864
  },
  {
    x: 961.44,
    torque: 346.625,
    y: 12.4937
  },
  {
    x: 962.04,
    torque: 346.827,
    y: 12.501
  },
  {
    x: 962.64,
    torque: 347.08,
    y: 12.5083
  },
  {
    x: 963.24,
    torque: 347.358,
    y: 12.5138
  },
  {
    x: 963.86,
    torque: 347.611,
    y: 12.5229
  },
  {
    x: 964.48,
    torque: 347.788,
    y: 12.5312
  },
  {
    x: 965.1,
    torque: 348.04,
    y: 12.5385
  },
  {
    x: 965.72,
    torque: 348.293,
    y: 12.5394
  },
  {
    x: 966.32,
    torque: 348.496,
    y: 12.5449
  },
  {
    x: 966.94,
    torque: 348.748,
    y: 12.5558
  },
  {
    x: 967.54,
    torque: 348.976,
    y: 12.5622
  },
  {
    x: 968.14,
    torque: 349.254,
    y: 12.5705
  },
  {
    x: 968.74,
    torque: 349.456,
    y: 12.5769
  },
  {
    x: 969.36,
    torque: 349.684,
    y: 12.5851
  },
  {
    x: 969.98,
    torque: 349.937,
    y: 12.596
  },
  {
    x: 970.6,
    torque: 350.164,
    y: 12.6006
  },
  {
    x: 971.2,
    torque: 350.392,
    y: 12.6088
  },
  {
    x: 971.8,
    torque: 350.594,
    y: 12.6125
  },
  {
    x: 972.4,
    torque: 350.847,
    y: 12.6235
  },
  {
    x: 973.02,
    torque: 351.075,
    y: 12.6271
  },
  {
    x: 973.64,
    torque: 351.327,
    y: 12.6353
  },
  {
    x: 974.26,
    torque: 351.555,
    y: 12.6436
  },
  {
    x: 974.88,
    torque: 351.858,
    y: 12.65
  },
  {
    x: 975.5,
    torque: 352.137,
    y: 12.6582
  },
  {
    x: 976.12,
    torque: 352.339,
    y: 12.6655
  },
  {
    x: 976.74,
    torque: 352.592,
    y: 12.6728
  },
  {
    x: 977.36,
    torque: 352.819,
    y: 12.6801
  },
  {
    x: 977.96,
    torque: 353.097,
    y: 12.6829
  },
  {
    x: 978.56,
    torque: 353.325,
    y: 12.6893
  },
  {
    x: 979.16,
    torque: 353.578,
    y: 12.6984
  },
  {
    x: 979.78,
    torque: 353.805,
    y: 12.7057
  },
  {
    x: 980.38,
    torque: 354.033,
    y: 12.7139
  },
  {
    x: 980.98,
    torque: 354.26,
    y: 12.7221
  },
  {
    x: 981.58,
    torque: 354.513,
    y: 12.7313
  },
  {
    x: 982.18,
    torque: 354.741,
    y: 12.7368
  },
  {
    x: 982.78,
    torque: 354.968,
    y: 12.745
  },
  {
    x: 983.4,
    torque: 355.221,
    y: 12.7514
  },
  {
    x: 984.02,
    torque: 355.424,
    y: 12.755
  },
  {
    x: 984.64,
    torque: 355.651,
    y: 12.7624
  },
  {
    x: 985.26,
    torque: 355.879,
    y: 12.7678
  },
  {
    x: 985.88,
    torque: 356.131,
    y: 12.7788
  },
  {
    x: 986.48,
    torque: 356.359,
    y: 12.7861
  },
  {
    x: 987.08,
    torque: 356.587,
    y: 12.7916
  },
  {
    x: 987.68,
    torque: 356.814,
    y: 12.7962
  },
  {
    x: 988.28,
    torque: 357.092,
    y: 12.8035
  },
  {
    x: 988.9,
    torque: 357.345,
    y: 12.8135
  },
  {
    x: 989.5,
    torque: 357.547,
    y: 12.819
  },
  {
    x: 990.1,
    torque: 357.8,
    y: 12.8263
  },
  {
    x: 990.72,
    torque: 358.053,
    y: 12.8327
  },
  {
    x: 991.32,
    torque: 358.281,
    y: 12.8382
  },
  {
    x: 991.94,
    torque: 358.534,
    y: 12.8464
  },
  {
    x: 992.56,
    torque: 358.71,
    y: 12.8519
  },
  {
    x: 993.18,
    torque: 359.014,
    y: 12.861
  },
  {
    x: 993.8,
    torque: 359.317,
    y: 12.8684
  },
  {
    x: 994.42,
    torque: 359.545,
    y: 12.8757
  },
  {
    x: 995.02,
    torque: 359.772,
    y: 12.8839
  },
  {
    x: 995.62,
    torque: 360,
    y: 12.8903
  },
  {
    x: 996.22,
    torque: 360.253,
    y: 12.8949
  },
  {
    x: 996.84,
    torque: 360.43,
    y: 12.9003
  },
  {
    x: 997.46,
    torque: 360.657,
    y: 12.9086
  },
  {
    x: 998.06,
    torque: 360.86,
    y: 12.915
  },
  {
    x: 998.68,
    torque: 361.138,
    y: 12.9241
  },
  {
    x: 999.28,
    torque: 361.34,
    y: 12.9305
  },
  {
    x: 999.9,
    torque: 361.593,
    y: 12.9369
  },
  {
    x: 1000.5,
    torque: 361.871,
    y: 12.9433
  },
  {
    x: 1001.1,
    torque: 362.073,
    y: 12.9515
  },
  {
    x: 1001.72,
    torque: 362.351,
    y: 12.9579
  },
  {
    x: 1002.34,
    torque: 362.579,
    y: 12.9643
  },
  {
    x: 1002.96,
    torque: 362.857,
    y: 12.9707
  },
  {
    x: 1003.56,
    torque: 363.059,
    y: 12.9798
  },
  {
    x: 1004.16,
    torque: 363.287,
    y: 12.9862
  },
  {
    x: 1004.76,
    torque: 363.489,
    y: 12.9936
  },
  {
    x: 1005.36,
    torque: 363.717,
    y: 12.9999
  },
  {
    x: 1005.98,
    torque: 364.02,
    y: 13.0091
  },
  {
    x: 1006.6,
    torque: 364.223,
    y: 13.0118
  },
  {
    x: 1007.2,
    torque: 364.475,
    y: 13.0173
  },
  {
    x: 1007.8,
    torque: 364.703,
    y: 13.0264
  },
  {
    x: 1008.4,
    torque: 364.981,
    y: 13.0328
  },
  {
    x: 1009.02,
    torque: 365.209,
    y: 13.0411
  },
  {
    x: 1009.64,
    torque: 365.436,
    y: 13.0475
  },
  {
    x: 1010.26,
    torque: 365.664,
    y: 13.0557
  },
  {
    x: 1010.88,
    torque: 365.917,
    y: 13.0612
  },
  {
    x: 1011.5,
    torque: 366.144,
    y: 13.0694
  },
  {
    x: 1012.12,
    torque: 366.372,
    y: 13.0785
  },
  {
    x: 1012.74,
    torque: 366.625,
    y: 13.0831
  },
  {
    x: 1013.36,
    torque: 366.877,
    y: 13.0904
  },
  {
    x: 1013.96,
    torque: 367.105,
    y: 13.0959
  },
  {
    x: 1014.56,
    torque: 367.332,
    y: 13.1023
  },
  {
    x: 1015.16,
    torque: 367.585,
    y: 13.1105
  },
  {
    x: 1015.78,
    torque: 367.838,
    y: 13.1169
  },
  {
    x: 1016.4,
    torque: 368.091,
    y: 13.1206
  },
  {
    x: 1017.02,
    torque: 368.268,
    y: 13.1279
  },
  {
    x: 1017.64,
    torque: 368.546,
    y: 13.1388
  },
  {
    x: 1018.24,
    torque: 368.774,
    y: 13.1407
  },
  {
    x: 1018.84,
    torque: 369.052,
    y: 13.1526
  },
  {
    x: 1019.46,
    torque: 369.279,
    y: 13.1571
  },
  {
    x: 1020.08,
    torque: 369.532,
    y: 13.1644
  },
  {
    x: 1020.7,
    torque: 369.785,
    y: 13.1699
  },
  {
    x: 1021.3,
    torque: 370.013,
    y: 13.1772
  },
  {
    x: 1021.92,
    torque: 370.265,
    y: 13.1809
  },
  {
    x: 1022.54,
    torque: 370.493,
    y: 13.1909
  },
  {
    x: 1023.16,
    torque: 370.746,
    y: 13.1992
  },
  {
    x: 1023.76,
    torque: 370.999,
    y: 13.2083
  },
  {
    x: 1024.36,
    torque: 371.226,
    y: 13.2138
  },
  {
    x: 1024.96,
    torque: 371.454,
    y: 13.222
  },
  {
    x: 1025.56,
    torque: 371.732,
    y: 13.2266
  },
  {
    x: 1026.18,
    torque: 371.96,
    y: 13.2321
  },
  {
    x: 1026.8,
    torque: 372.187,
    y: 13.243
  },
  {
    x: 1027.4,
    torque: 372.415,
    y: 13.2503
  },
  {
    x: 1028,
    torque: 372.642,
    y: 13.2549
  },
  {
    x: 1028.62,
    torque: 372.895,
    y: 13.2622
  },
  {
    x: 1029.22,
    torque: 373.097,
    y: 13.2695
  },
  {
    x: 1029.84,
    torque: 373.35,
    y: 13.2787
  },
  {
    x: 1030.46,
    torque: 373.603,
    y: 13.2841
  },
  {
    x: 1031.06,
    torque: 373.906,
    y: 13.2924
  },
  {
    x: 1031.68,
    torque: 374.109,
    y: 13.3006
  },
  {
    x: 1032.3,
    torque: 374.362,
    y: 13.3061
  },
  {
    x: 1032.9,
    torque: 374.539,
    y: 13.3116
  },
  {
    x: 1033.5,
    torque: 374.817,
    y: 13.318
  },
  {
    x: 1034.12,
    torque: 375.044,
    y: 13.3262
  },
  {
    x: 1034.72,
    torque: 375.247,
    y: 13.3335
  },
  {
    x: 1035.34,
    torque: 375.474,
    y: 13.3417
  },
  {
    x: 1035.96,
    torque: 375.702,
    y: 13.3472
  },
  {
    x: 1036.58,
    torque: 375.98,
    y: 13.3563
  },
  {
    x: 1037.18,
    torque: 376.207,
    y: 13.3618
  },
  {
    x: 1037.78,
    torque: 376.435,
    y: 13.3691
  },
  {
    x: 1038.4,
    torque: 376.662,
    y: 13.3746
  },
  {
    x: 1039.02,
    torque: 376.915,
    y: 13.3838
  },
  {
    x: 1039.64,
    torque: 377.219,
    y: 13.3901
  },
  {
    x: 1040.26,
    torque: 377.421,
    y: 13.3993
  },
  {
    x: 1040.88,
    torque: 377.674,
    y: 13.4029
  },
  {
    x: 1041.5,
    torque: 377.927,
    y: 13.413
  },
  {
    x: 1042.12,
    torque: 378.18,
    y: 13.423
  },
  {
    x: 1042.74,
    torque: 378.407,
    y: 13.4294
  },
  {
    x: 1043.34,
    torque: 378.609,
    y: 13.4349
  },
  {
    x: 1043.94,
    torque: 378.913,
    y: 13.4386
  },
  {
    x: 1044.54,
    torque: 379.166,
    y: 13.445
  },
  {
    x: 1045.16,
    torque: 379.393,
    y: 13.4541
  },
  {
    x: 1045.78,
    torque: 379.671,
    y: 13.4605
  },
  {
    x: 1046.4,
    torque: 379.924,
    y: 13.466
  },
  {
    x: 1047.02,
    torque: 380.152,
    y: 13.4733
  },
  {
    x: 1047.64,
    torque: 380.354,
    y: 13.4806
  },
  {
    x: 1048.24,
    torque: 380.531,
    y: 13.4898
  },
  {
    x: 1048.84,
    torque: 380.784,
    y: 13.4961
  },
  {
    x: 1049.44,
    torque: 381.011,
    y: 13.5016
  },
  {
    x: 1050.06,
    torque: 381.239,
    y: 13.5089
  },
  {
    x: 1050.68,
    torque: 381.466,
    y: 13.5135
  },
  {
    x: 1051.28,
    torque: 381.719,
    y: 13.5217
  },
  {
    x: 1051.9,
    torque: 381.947,
    y: 13.5318
  },
  {
    x: 1052.5,
    torque: 382.174,
    y: 13.5364
  },
  {
    x: 1053.1,
    torque: 382.453,
    y: 13.5418
  },
  {
    x: 1053.7,
    torque: 382.68,
    y: 13.5519
  },
  {
    x: 1054.3,
    torque: 382.908,
    y: 13.5574
  },
  {
    x: 1054.92,
    torque: 383.085,
    y: 13.5638
  },
  {
    x: 1055.52,
    torque: 383.338,
    y: 13.5693
  },
  {
    x: 1056.14,
    torque: 383.59,
    y: 13.5775
  },
  {
    x: 1056.74,
    torque: 383.818,
    y: 13.583
  },
  {
    x: 1057.34,
    torque: 384.096,
    y: 13.5921
  },
  {
    x: 1057.96,
    torque: 384.324,
    y: 13.5976
  },
  {
    x: 1058.58,
    torque: 384.577,
    y: 13.6058
  },
  {
    x: 1059.2,
    torque: 384.829,
    y: 13.6122
  },
  {
    x: 1059.82,
    torque: 385.082,
    y: 13.6186
  },
  {
    x: 1060.44,
    torque: 385.335,
    y: 13.6277
  },
  {
    x: 1061.04,
    torque: 385.537,
    y: 13.6323
  },
  {
    x: 1061.66,
    torque: 385.765,
    y: 13.6396
  },
  {
    x: 1062.26,
    torque: 386.018,
    y: 13.6478
  },
  {
    x: 1062.86,
    torque: 386.195,
    y: 13.6515
  },
  {
    x: 1063.48,
    torque: 386.473,
    y: 13.6606
  },
  {
    x: 1064.1,
    torque: 386.7,
    y: 13.6661
  },
  {
    x: 1064.72,
    torque: 386.979,
    y: 13.6716
  },
  {
    x: 1065.34,
    torque: 387.206,
    y: 13.6807
  },
  {
    x: 1065.96,
    torque: 387.509,
    y: 13.6917
  },
  {
    x: 1066.56,
    torque: 387.712,
    y: 13.6963
  },
  {
    x: 1067.18,
    torque: 387.939,
    y: 13.7045
  },
  {
    x: 1067.78,
    torque: 388.142,
    y: 13.71
  },
  {
    x: 1068.38,
    torque: 388.42,
    y: 13.7146
  },
  {
    x: 1069,
    torque: 388.673,
    y: 13.7246
  },
  {
    x: 1069.62,
    torque: 388.925,
    y: 13.7283
  },
  {
    x: 1070.22,
    torque: 389.153,
    y: 13.7337
  },
  {
    x: 1070.84,
    torque: 389.381,
    y: 13.7429
  },
  {
    x: 1071.44,
    torque: 389.659,
    y: 13.7511
  },
  {
    x: 1072.04,
    torque: 389.886,
    y: 13.7584
  },
  {
    x: 1072.64,
    torque: 390.088,
    y: 13.7657
  },
  {
    x: 1073.24,
    torque: 390.291,
    y: 13.773
  },
  {
    x: 1073.86,
    torque: 390.569,
    y: 13.7776
  },
  {
    x: 1074.48,
    torque: 390.771,
    y: 13.7858
  },
  {
    x: 1075.1,
    torque: 391.024,
    y: 13.7922
  },
  {
    x: 1075.7,
    torque: 391.277,
    y: 13.7995
  },
  {
    x: 1076.3,
    torque: 391.504,
    y: 13.8059
  },
  {
    x: 1076.92,
    torque: 391.757,
    y: 13.8105
  },
  {
    x: 1077.52,
    torque: 391.934,
    y: 13.8196
  },
  {
    x: 1078.14,
    torque: 392.212,
    y: 13.826
  },
  {
    x: 1078.76,
    torque: 392.465,
    y: 13.837
  },
  {
    x: 1079.38,
    torque: 392.743,
    y: 13.8397
  },
  {
    x: 1080,
    torque: 393.021,
    y: 13.8471
  },
  {
    x: 1080.62,
    torque: 393.249,
    y: 13.8553
  },
  {
    x: 1081.22,
    torque: 393.527,
    y: 13.8617
  },
  {
    x: 1081.82,
    torque: 393.78,
    y: 13.8681
  },
  {
    x: 1082.42,
    torque: 393.957,
    y: 13.8736
  },
  {
    x: 1083.04,
    torque: 394.235,
    y: 13.879
  },
  {
    x: 1083.66,
    torque: 394.463,
    y: 13.8891
  },
  {
    x: 1084.26,
    torque: 394.716,
    y: 13.8964
  },
  {
    x: 1084.86,
    torque: 394.893,
    y: 13.9019
  },
  {
    x: 1085.46,
    torque: 395.12,
    y: 13.9074
  },
  {
    x: 1086.08,
    torque: 395.373,
    y: 13.9147
  },
  {
    x: 1086.7,
    torque: 395.626,
    y: 13.9238
  },
  {
    x: 1087.32,
    torque: 395.853,
    y: 13.9293
  },
  {
    x: 1087.94,
    torque: 396.081,
    y: 13.9366
  },
  {
    x: 1088.54,
    torque: 396.283,
    y: 13.9421
  },
  {
    x: 1089.16,
    torque: 396.561,
    y: 13.9531
  },
  {
    x: 1089.78,
    torque: 396.814,
    y: 13.9558
  },
  {
    x: 1090.38,
    torque: 397.067,
    y: 13.9649
  },
  {
    x: 1090.98,
    torque: 397.295,
    y: 13.9704
  },
  {
    x: 1091.58,
    torque: 397.522,
    y: 13.9759
  },
  {
    x: 1092.2,
    torque: 397.75,
    y: 13.9823
  },
  {
    x: 1092.82,
    torque: 398.003,
    y: 13.9905
  },
  {
    x: 1093.44,
    torque: 398.255,
    y: 13.9987
  },
  {
    x: 1094.04,
    torque: 398.508,
    y: 14.0042
  },
  {
    x: 1094.64,
    torque: 398.761,
    y: 14.0125
  },
  {
    x: 1095.24,
    torque: 399.014,
    y: 14.0179
  },
  {
    x: 1095.86,
    torque: 399.241,
    y: 14.0271
  },
  {
    x: 1096.48,
    torque: 399.52,
    y: 14.0307
  },
  {
    x: 1097.08,
    torque: 399.722,
    y: 14.0399
  },
  {
    x: 1097.7,
    torque: 399.949,
    y: 14.0444
  },
  {
    x: 1098.32,
    torque: 400.177,
    y: 14.0508
  },
  {
    x: 1098.92,
    torque: 400.329,
    y: 14.0572
  },
  {
    x: 1099.52,
    torque: 400.582,
    y: 14.0645
  },
  {
    x: 1100.12,
    torque: 400.834,
    y: 14.07
  },
  {
    x: 1100.74,
    torque: 401.087,
    y: 14.081
  },
  {
    x: 1101.34,
    torque: 401.315,
    y: 14.0865
  },
  {
    x: 1101.96,
    torque: 401.542,
    y: 14.0947
  },
  {
    x: 1102.56,
    torque: 401.77,
    y: 14.1002
  },
  {
    x: 1103.16,
    torque: 402.023,
    y: 14.1066
  },
  {
    x: 1103.76,
    torque: 402.301,
    y: 14.1102
  },
  {
    x: 1104.38,
    torque: 402.554,
    y: 14.1185
  },
  {
    x: 1104.98,
    torque: 402.756,
    y: 14.1276
  },
  {
    x: 1105.6,
    torque: 402.984,
    y: 14.1303
  },
  {
    x: 1106.22,
    torque: 403.236,
    y: 14.1376
  },
  {
    x: 1106.84,
    torque: 403.515,
    y: 14.1404
  },
  {
    x: 1107.44,
    torque: 403.742,
    y: 14.1504
  },
  {
    x: 1108.04,
    torque: 403.995,
    y: 14.1605
  },
  {
    x: 1108.64,
    torque: 404.248,
    y: 14.1669
  },
  {
    x: 1109.26,
    torque: 404.475,
    y: 14.1705
  },
  {
    x: 1109.88,
    torque: 404.753,
    y: 14.1788
  },
  {
    x: 1110.5,
    torque: 404.956,
    y: 14.1824
  },
  {
    x: 1111.12,
    torque: 405.234,
    y: 14.1906
  },
  {
    x: 1111.74,
    torque: 405.436,
    y: 14.198
  },
  {
    x: 1112.34,
    torque: 405.664,
    y: 14.2034
  },
  {
    x: 1112.96,
    torque: 405.917,
    y: 14.2108
  },
  {
    x: 1113.56,
    torque: 406.144,
    y: 14.2172
  },
  {
    x: 1114.18,
    torque: 406.422,
    y: 14.2226
  },
  {
    x: 1114.78,
    torque: 406.65,
    y: 14.2299
  },
  {
    x: 1115.4,
    torque: 406.928,
    y: 14.2336
  },
  {
    x: 1116.02,
    torque: 407.181,
    y: 14.24
  },
  {
    x: 1116.64,
    torque: 407.459,
    y: 14.2473
  },
  {
    x: 1117.24,
    torque: 407.712,
    y: 14.2537
  },
  {
    x: 1117.86,
    torque: 407.939,
    y: 14.2592
  },
  {
    x: 1118.46,
    torque: 408.167,
    y: 14.2638
  },
  {
    x: 1119.06,
    torque: 408.445,
    y: 14.2683
  },
  {
    x: 1119.68,
    torque: 408.698,
    y: 14.2738
  },
  {
    x: 1120.28,
    torque: 408.951,
    y: 14.2811
  },
  {
    x: 1120.9,
    torque: 409.178,
    y: 14.2829
  },
  {
    x: 1121.5,
    torque: 409.431,
    y: 14.2875
  },
  {
    x: 1122.1,
    torque: 409.684,
    y: 14.2912
  },
  {
    x: 1122.72,
    torque: 409.962,
    y: 14.2903
  },
  {
    x: 1123.32,
    torque: 410.24,
    y: 14.2866
  }
];

export default uniaxialpower;
